/* Initialize re-usable variable declarations */
var order_string_array, init_images_preloaded, all_images_preloaded, bundleBuilderWindowWidth, step, collection_titles, total_steps,bundlePricingDataArray, variant_data, selectVariantsArray, product_data, bundle_variant_matches_data, bundle_builder_swipers, removedButSavedAddonData, prevSelectedChairDesk, standInSwatchesRemoved, collectionDiscountCodeAmounts, urlArray, collectionTypeArray, selectedVariantsFromSessionStorage, bundleProductPage, bundleProductPageData, order_switched, urlParameterHandles, testActive;

/* Initialize element declarations */
var bundleBuilderContainer, formContainer, backForwardButtonsContainer, tabs, navTitleContainer, navSubTitleContainers, navButtons, navLineSections, mainImageContainers, selectedProductVariantsContainers, productContainersInEachTab, slideDownPrice, priceInstallmentsWrapper;

/* True when the builder is rendered inside the quick-view "Get the bundle" pop-up modal
   (the quick-view-bundle view wraps the section in .quick-view). In that context we ignore
   browse/selection history and use the prescribed preset variants (or first-available). */
const isBundleBuilderInModal = function(){
    return !!document.querySelector('.quick-view .bundle-builder-form, .tingle-modal .bundle-builder-form');
};

function initReusableVariableDeclarations(){

    /* Assign values to re-usable variable declarations */
    order_string_array = ['first', 'second', 'third', 'fourth', 'fifth'];
    init_images_preloaded = false;
    all_images_preloaded = false;

    step = 1;
    collection_titles = [];
    total_steps = parseInt(document.querySelector('.bundle-builder-form .bundle-builder-form__nav').getAttribute('data-button-count'));
    bundlePricingDataArray = [];
    variant_data = JSON.parse(document.querySelector('#bundle-variant-data').innerHTML);
    product_data = JSON.parse(document.querySelector('#bundle-product-data').innerHTML);
    bundle_variant_matches_data = document.querySelector('#bundle-variant-matches').innerHTML ? JSON.parse(document.querySelector('#bundle-variant-matches').innerHTML) : [];
    current_compatible_addons = [];
    bundle_builder_swipers = [];
    removedButSavedAddonData = {};
    prevSelectedChairDesk = [undefined, undefined];
    collectionHeaderText = [];
    standInSwatchesRemoved = false;
    collectionDiscountCodeAmounts = [];
    bundleBuilderWindowWidth = window.innerWidth;
    urlArray = [window.Branch.functions.returnCookieURL('lastVisitURL'), window.Branch.functions.returnCookieURL('secondToLastVisitURL')];
    urlParameterHandles = Object.fromEntries(new URLSearchParams(location.search).entries()); Object.fromEntries(Object.entries(urlParameterHandles).map(([k, v]) => [k, v.split(',')]));
    collectionTypeArray = [];
    // In the pop-up modal, ignore previously-stored selections so the preset (or first-available)
    // variants win instead of being overridden by history.
    selectedVariantsFromSessionStorage = (!isBundleBuilderInModal() && sessionStorage.getItem("selectedBundleVariants")) ? correctSessionStorageOrder(JSON.parse(sessionStorage.getItem("selectedBundleVariants"))) : [];
    bundleProductPage = document.querySelector('body.templateProduct.template-product-bundle') ? true : false;
    // Drive preset preselection off the presence of #preset-bundle-data rather than the host
    // page's body class, so the quick-view "Get the bundle" pop-up (which injects this script
    // into a modal on a non-bundle PDP) preselects the preset constituents too.
    bundleProductPageData = document.querySelector('#preset-bundle-data') && document.querySelector('#preset-bundle-data').innerHTML ? JSON.parse(document.querySelector('#preset-bundle-data').innerHTML) : [];
    testActive = document.querySelector('#bundles-test') && document.querySelector('#bundles-test').getAttribute('data-test-active') == 'true' && bundleProductPage ? true : false;

    if(testActive){
        document.querySelectorAll('.bundle-builder-form__tab#third, .bundle-builder-form__tab#fourth').forEach((tab) => {
            tab.remove();
        });
        document.querySelectorAll('#bundle-builder-form__nav-button--third, #bundle-builder-form__nav-button--fourth').forEach((navButton) => {
            navButton.remove();
        });
        total_steps = total_steps - 2;
        document.querySelector('.bundle-builder-form .bundle-builder-form__nav').setAttribute('data-button-count', total_steps)
    }

    // Track the visited bundle product so addon/accessory selections clear when moving
    // between different bundles. Done here (not via an inline <script> in the section) so
    // it also runs in the quick-view pop-up, where injected inline scripts never execute.
    const presetBundleEl = document.querySelector('#preset-bundle-data');
    const currentBundleHandle = presetBundleEl ? presetBundleEl.getAttribute('data-bundle-handle') : null;
    if(currentBundleHandle){
        if(sessionStorage.getItem('currentVisitedBundleProductPage') != null){
            sessionStorage.setItem('prevVisitedBundleProductPage', sessionStorage.getItem('currentVisitedBundleProductPage'));
        }
        sessionStorage.setItem('currentVisitedBundleProductPage', currentBundleHandle);
    }

    updateSelectedVariantsArrayFromURLParameters();
    bundleProductPageUpdateSelectedVariants();
    selectVariantsArray = selectedVariantsFromSessionStorage.length > 0 ? JSON.parse(JSON.stringify(selectedVariantsFromSessionStorage)) : [];

    if(selectedVariantsFromSessionStorage.length > 0){
        shiftSelectedVariantsFromSessionStorageToStart();
    }

    /* Assign values to element declarations */
    bundleBuilderContainer = document.querySelector('.bundle-builder');
    formContainer = document.querySelector('.bundle-builder-form');
    backForwardButtonsContainer = document.querySelector('.bundle-builder__back-forward-buttons');
    tabs = document.querySelectorAll('.bundle-builder-form__tab');
    navTitleContainer = document.querySelector('.bundle-builder-form__nav-main-title-container h4');
    navSubTitleContainers = document.querySelectorAll('.bundle-builder-form__nav-main-title-container .bundle-builder-form__nav-main-subtitle');
    navButtons = document.querySelectorAll('.bundle-builder-form__nav button');
    navLineSections = document.querySelectorAll('.bundle-builder-form__nav .bundle-builder-form__nav-process-indicator-line-section');
    mainImageContainers = document.querySelectorAll(`.bundle-builder-gallery__main-image-sub-container`);
    selectedProductVariantsContainers = document.querySelectorAll('.bundle-builder-form__selected-product-variants-container')
    productContainersInEachTab = [];
    slideDownPrice = document.querySelector('.bundle-builder__slide-down-pricing');
    priceInstallmentsWrapper = document.querySelector('.price-installments-wrapper.price-installments-wrapper__bundles');


    /* Add all collection titles to 'collection_titles' array */
    document.querySelectorAll('.bundle-builder-form__nav-button-title span').forEach((title) => {
        collection_titles.push(title.innerHTML)
    });

    /* Add all pricing data to 'bundlePricingDataArray' array */
    document.querySelectorAll('.bundle-pricing-data').forEach((dataObject) => {
        bundlePricingDataArray.push(JSON.parse(dataObject.innerHTML));
    });

    /* Init an entry for every desk/chair prodict in the 'removedButSavedAddonData' object */
    document.querySelectorAll('.bundle-builder-form__tab[data-index="0"] .bundle-builder-form__product-container, .bundle-builder-form__tab[data-index="1"] .bundle-builder-form__product-container').forEach((chairDeskProduct) => {
        removedButSavedAddonData[`${parseInt(chairDeskProduct.getAttribute('data-product-id'))}`] = [];
    });

    document.querySelectorAll('.bundle-builder-form__nav-inner-container .bundle-builder-form__nav-button').forEach((navButton) => {
        collectionHeaderText.push(navButton.getAttribute('data-nav-title-text'));
    });

    /* Add the product containers in each tab to their own array within the 'productContainersInEachTab' array */
    tabs.forEach((tab, index) => {
        if(index != tabs.length - 1){
            productContainersInEachTab[index] = tab.querySelectorAll('.bundle-builder-form__product-container')
            collectionDiscountCodeAmounts.push(parseInt(tab.getAttribute('data-discount-amount')));
            collectionTypeArray.push(tab.getAttribute('data-type'))
        }
    });
}

/* Reusable functions */

/* Right side scroll that works on checking the height of the builder */
function adjustStickyTop() {
    if (window.innerWidth >= 900) {
        var productInfo = document.querySelector('.bundle-builder__info-outer-container');
        var productInfoHeight = productInfo.offsetHeight;
        var viewportHeight = window.innerHeight;
        var offset = 130;

        if (viewportHeight - offset < productInfoHeight) {
            var topValue = viewportHeight - productInfoHeight;
            productInfo.style.top = (topValue -15) + 'px';
        } else {
            productInfo.style.top = '';
        }
    } else {
        var productInfo = document.querySelector('.bundle-builder__info-outer-container');
        productInfo.style.top = '';
    }
}

/* Function that returns true or false, depending on whether the two arrays it is passed are identical */
const arraysMatch = (arr1, arr2) => JSON.stringify(arr1) !== JSON.stringify(arr2);

/* Function that reversed the changes rendered to a string by the Liquid 'escape' tag  */
const unescapeHtml = function(escapedString) {
    let entities = {'&amp;': '&', '&lt;': '<', '&gt;': '>', '&quot;': '"', '&#39;': "'", '&#x2F;': '/', '&#x60;': '`', '&#x3D;': '='};
    return escapedString.replace(/&amp;|&lt;|&gt;|&quot;|&#39;|&#x2F;|&#x60;|&#x3D;/g, function(match) {
        return entities[match];
    });
}

const updateSelectedVariantsArrayFromURLParameters = function() {
    if (Object.entries(urlParameterHandles).length > 0 && (urlParameterHandles['pre_select_chair_product'] || urlParameterHandles['pre_select_desk_product'])) {
        let chairIndex = order_switched ? 1 : 0;

        if (selectedVariantsFromSessionStorage.length > 0) {
            chairIndex = selectedVariantsFromSessionStorage.findIndex(
                group => group[0]?.collection === 'chairs'
            );
        }

        let deskIndex = chairIndex === 0 ? 1 : 0;
        let tempURLParamsSelectedVariantsFromSessionStorage = selectedVariantsFromSessionStorage.length > 0 
            ? JSON.parse(JSON.stringify(selectedVariantsFromSessionStorage)) 
            : [[], [], [], []];

        const replacements = [
            {
                param: 'pre_select_chair_product',
                index: chairIndex
            },
            {
                param: 'pre_select_desk_product',
                index: deskIndex
            },
            {
                param: 'pre_select_addon_product',
                index: 2
            },
            {
                param: 'pre_select_accessory_product',
                index: 3
            }
        ];

        replacements.forEach(({ param, index }) => {
            const productIds = urlParameterHandles[param];
            
            if (productIds?.length > 0) {
                let productIdsArray = productIds.split(',');
                productIdsArray.forEach((productId, productIdIndex) => {
                    const replacementData = { 
                        ...variant_data[`${productId}`], 
                        variant_id: productId 
                    };
    
                    if (tempURLParamsSelectedVariantsFromSessionStorage[index]?.[productIdIndex]) {
                        tempURLParamsSelectedVariantsFromSessionStorage[index][productIdIndex] = replacementData;
                    } else {
                        tempURLParamsSelectedVariantsFromSessionStorage[index].push(replacementData);
                    }
                })
                
            } else if (index < 2){
                let initially_selected_variant_ids = Array.from(document.querySelectorAll('.bundle-builder-form__tab[data-index="0"] .bundle-builder-form__product-container[data-selected="true"], .bundle-builder-form__tab[data-index="1"] .bundle-builder-form__product-container[data-selected="true"] .swatches-container')).map(el => parseInt(el.getAttribute('data-first-available-or-selected-variant-id')));
                let replacementData = {
                    ...variant_data[initially_selected_variant_ids[index]], 
                        variant_id: `${initially_selected_variant_ids[index]}`
                }
                
                if (tempURLParamsSelectedVariantsFromSessionStorage[index]?.[0]) {
                    tempURLParamsSelectedVariantsFromSessionStorage[index][0] = replacementData;
                } else {
                    tempURLParamsSelectedVariantsFromSessionStorage[index].push(replacementData);
                }
            }
        });

        if(tempURLParamsSelectedVariantsFromSessionStorage[2]){
            let compatible_addons = tempURLParamsSelectedVariantsFromSessionStorage[0][0] && tempURLParamsSelectedVariantsFromSessionStorage[1][0] ? [tempURLParamsSelectedVariantsFromSessionStorage[0][0]['product_id'], tempURLParamsSelectedVariantsFromSessionStorage[1][0]['product_id']].flatMap(id => product_data[id].addon_handles.replace(/\s/g, '').split(',')) : [];
            tempURLParamsSelectedVariantsFromSessionStorage[2] = tempURLParamsSelectedVariantsFromSessionStorage[2].filter(addonFromSessionStorage => {
                return compatible_addons.includes(addonFromSessionStorage['product_handle']);
            });
        }

        if(tempURLParamsSelectedVariantsFromSessionStorage.length > 0){
            document.querySelectorAll('.bundle-builder-gallery__preset-loading-image').forEach((container, index) => {
                if(index == 0){
                    let innerHTML = `<div class="product-image shown collectionHero">
                                        <div class="pre-set-bundle-image-container">
                                            ${tempURLParamsSelectedVariantsFromSessionStorage[0][0]['bundle_builder_image']['default'] && `<img src="${tempURLParamsSelectedVariantsFromSessionStorage[0][0]['bundle_builder_image']['default']}" class="pre-set-bundle-image__product-overlay" width="500" height="500" srcset="${tempURLParamsSelectedVariantsFromSessionStorage[0][0]['bundle_builder_image']['default']}&amp;width=180 180w,${tempURLParamsSelectedVariantsFromSessionStorage[0][0]['bundle_builder_image']['default']}&amp;width=360 360w" sizes="(max-width: 600px) calc(100vw - 48px), (max-width: 840px) calc((100vw - 148px) /2), (max-width: 900px) calc((77.77vw - 20px) /2), (max-width: 1440px) calc((77.77vw - 40px) /3), calc((1120px - 40px) / 3)" alt="Color: Shore; excluded_addon_handle: ergonomic-pro-headrest" loading="lazy">`}
                                            ${tempURLParamsSelectedVariantsFromSessionStorage[1][0]['bundle_builder_image']['default'] && `<img src="${tempURLParamsSelectedVariantsFromSessionStorage[1][0]['bundle_builder_image']['default']}" class="pre-set-bundle-image__product-overlay" width="500" height="500" srcset="${tempURLParamsSelectedVariantsFromSessionStorage[1][0]['bundle_builder_image']['default']}&amp;width=180 180w,${tempURLParamsSelectedVariantsFromSessionStorage[1][0]['bundle_builder_image']['default']}&amp;width=360 360w" sizes="(max-width: 600px) calc(100vw - 48px), (max-width: 840px) calc((100vw - 148px) /2), (max-width: 900px) calc((77.77vw - 20px) /2), (max-width: 1440px) calc((77.77vw - 40px) /3), calc((1120px - 40px) / 3)" alt="Color: Shore; excluded_addon_handle: ergonomic-pro-headrest" loading="lazy">`}
                                        </div>  
                                    </div>`
                    container.innerHTML = innerHTML;
                } else {
                    if(tempURLParamsSelectedVariantsFromSessionStorage[index - 1][0]['image_url']){
                        let innerHTML = `<img src="${tempURLParamsSelectedVariantsFromSessionStorage[index - 1][0]['image_url']}" width="500" height="500" srcset="${tempURLParamsSelectedVariantsFromSessionStorage[index - 1][0]['image_url']}&amp;width=180 180w" sizes="100vw" alt="Image" loading="eager" fetchpriority="high">`
                        container.innerHTML = innerHTML;
                    }
                }
            });
        }

        selectedVariantsFromSessionStorage = tempURLParamsSelectedVariantsFromSessionStorage;
    } else if (bundleProductPageData.length == 0){
        setTimeout(() => {
            document.querySelectorAll('.bundle-builder-gallery__preset-loading-image').forEach((loadingImage) => {loadingImage.setAttribute('data-visible', false)});
            document.querySelectorAll('.bundle-builder-gallery__main-image-container').forEach((mainImage) => {mainImage.style.removeProperty('opacity')});
        }, 250)
    }
}

const checkAddonsToHideForVariant = function(productId, variantData, product) {
    let updateNeeded = false;
    let indexOfSwipersToUpdate = [];

    if(selectVariantsArray && selectVariantsArray.length > 0){
        let selectedCategoryVariant = selectVariantsArray.flat().find(variant => variant.collection == variantData.collection);
        if(selectedCategoryVariant.product_id == variantData.product_id){
        const addonElement = document.querySelector(`.addons_to_hide_when_variant_selected[data-product-id="${productId}"]`);

        if (addonElement) {
            let handlesToHide = [];
            let addonsToHideWhenVariantSelectedData = JSON.parse(document.querySelector(`.addons_to_hide_when_variant_selected[data-product-id="${productId}"]`).innerText);

            addonsToHideWhenVariantSelectedData.forEach((dataLine) => {
                let index = product.options.findIndex(optionName => optionName.toLowerCase() === dataLine.option_name.toLowerCase());
                if(variantData[`option${index + 1}`] && variantData[`option${index + 1}`] == dataLine.option_value && dataLine.hide_on_bundle_builder == true){
                handlesToHide.push(dataLine.addon_handle.toLowerCase());
                }
            })

            document.querySelectorAll(`.bundle-builder-form__product-container[data-hidden-via-metafield="true"]`).forEach((addonElementToShow) => {
                addonElementToShow.style.display = '';
                addonElementToShow.setAttribute('data-hidden-via-metafield', 'false');
                    updateNeeded = true;
                    indexOfSwipersToUpdate.push(parseInt(addonElementToShow.closest('.bundle-builder-form__tab').getAttribute('data-index')));
            });

            handlesToHide.forEach((handleToHide) => {
                let addonElementsToHide = document.querySelectorAll(`.bundle-builder-form__product-container[data-product-handle="${handleToHide}"]`);
                if(addonElementsToHide.length > 0){
                    updateNeeded = true;
                addonElementsToHide.forEach((addonElementToHide) => {
                    indexOfSwipersToUpdate.push(parseInt(addonElementToHide.closest('.bundle-builder-form__tab').getAttribute('data-index')));

                    addonElementToHide.setAttribute('data-hidden-via-metafield', 'true');
                    addonElementToHide.style.display = 'none';
                })
                }
            })
        }
        }
    }
    
    if(updateNeeded){
        let uniqueIndexes = [...new Set(indexOfSwipersToUpdate)];
        uniqueIndexes.forEach((index) => {
            if(bundle_builder_swipers[index]){
                bundle_builder_swipers[index].update();
            }
        });
    }
};

const shiftSelectedVariantsFromSessionStorageToStart = function(){
    selectedVariantsFromSessionStorage.forEach((itemGroup, groupIndex) => {
        if (itemGroup.length > 0) {
          const firstItem = itemGroup[0];
          const collection = firstItem.collection;
          const productHandle = firstItem.product_handle;
            let carouselItems;
            if(collection == 'addons' || collection == 'accessories' || collection == 'other'){
                const tab = document.querySelector(`.bundle-builder-form__tab[data-index="${groupIndex}"]`);
                if(tab){
                    carouselItems = tab.querySelectorAll('.bundle-builder-form__product-container');
                }
            } else {
                const carouselSelector = `.bundle-builder-form__tab[data-type="${collection == 'addons' ? 'other' : collection}"] .bundle-builder-form__product-container`;
                carouselItems = document.querySelectorAll(carouselSelector);
            }

            if (carouselItems && carouselItems.length > 1) {
              const parentContainer = carouselItems[0].parentElement;
              let matchingTile = null;
              carouselItems.forEach(item => {
                if (item.getAttribute('data-product-handle') === productHandle) {
                  matchingTile = item;
                }
              });

              if (matchingTile) {
                const clonedTile = matchingTile.cloneNode(true);
                matchingTile.remove();
                parentContainer.insertBefore(clonedTile, parentContainer.firstChild);
            }
            }    
        }
      });
}

/* Function that updates the selected addons, by modified the input element and the 'selectVariantsArray' array */
const updateAddons = function(type, addonObject, tab_index, variantId){
    let input = document.querySelector(`.bundle-builder-form__tab[data-index="${tab_index}"]`).querySelector('input.bundle-builder-form__addons-input');
    let currentAddonsData = input && input.getAttribute('value') ? JSON.parse(`${input.getAttribute('value')}`) : [];
    let replacementIndex = currentAddonsData.findIndex(item => item.productHandle == addonObject['productHandle']);
        
        if (replacementIndex !== -1) {
            currentAddonsData.splice(replacementIndex, 1);
        }
        currentAddonsData.push(addonObject);


    if(replacementIndex >= 0 || type == "add"){
        input.value = JSON.stringify(currentAddonsData);
        input.setAttribute('value', JSON.stringify(currentAddonsData));
        selectVariantsArray[tab_index][replacementIndex] = variant_data[`${variantId}`];
        saveSelectedVariantsToLocalStorage();
    }
}

//get the Clarity User ID
function getClarityUserId() {
    var cookies = document.cookie.split('; ');
    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i].split('=');
        if (cookie[0] === '_clsk' || cookie[0] === '_clck') {
            var fullValue = decodeURIComponent(cookie[1].trim());
            var userId = fullValue.split('|')[0];
            return userId;
        }
    }
    return null;
}

const bundleProductPageUpdateSelectedVariants = function(){
    if(bundleProductPageData.length > 0){
        let presetChair = {};
        let presetDesk = {};
        let presetAddons = [];
        let presetAccessories = [];
        let noSessionStorage = selectedVariantsFromSessionStorage.length == 0;
        
        bundleProductPageData.forEach((presetBundleConstituent) => {
           let constituentType = presetBundleConstituent.type || '';
            if(constituentType.indexOf("chair") === 0){
                presetChair = variant_data[presetBundleConstituent.id];
                presetChair.variant_id = presetBundleConstituent.id;
                presetChair.product_handle = presetBundleConstituent.handle;
            } else if(constituentType.indexOf("desk") === 0) {
                presetDesk = variant_data[presetBundleConstituent.id];
                presetDesk.variant_id = presetBundleConstituent.id;
                presetDesk.product_handle = presetBundleConstituent.handle;
            } else {
                let presetAddonAccessory = variant_data[presetBundleConstituent.id];
                if(presetAddonAccessory){
                    // console.log('presetAddonAccessory', presetAddonAccessory);
                    presetAddonAccessory.variant_id = presetBundleConstituent.id;
                    presetAddonAccessory.product_handle = presetBundleConstituent.handle;
                    if(presetBundleConstituent.type == "add-on"){
                        presetAddons.push(presetAddonAccessory);
                    } else {
                        presetAccessories.push(presetAddonAccessory);
                    }
                }
            }
        });

        // console.log('presetAddons', presetAddons)
        // console.log('presetAccessories', presetAccessories)

        if(noSessionStorage){
            selectedVariantsFromSessionStorage = [[], [], [], []];
        }

        let existingChairSlot = selectedVariantsFromSessionStorage[order_switched == false ? 0 : 1][0];
        if(noSessionStorage || !existingChairSlot || existingChairSlot['product_handle'] !== presetChair.product_handle){
            if(presetChair.product_id){selectedVariantsFromSessionStorage[order_switched == false ? 0 : 1][0] = presetChair};
        }

        let existingDeskSlot = selectedVariantsFromSessionStorage[order_switched == false ? 1 : 0][0];
        if(noSessionStorage || !existingDeskSlot || existingDeskSlot['product_handle'] !== presetDesk.product_handle){
            if(presetDesk.product_id){selectedVariantsFromSessionStorage[order_switched == false ? 1 : 0][0] = presetDesk};
        }

        if(sessionStorage.getItem('prevVisitedBundleProductPage') && sessionStorage.getItem('currentVisitedBundleProductPage') && sessionStorage.getItem('prevVisitedBundleProductPage') !== sessionStorage.getItem('currentVisitedBundleProductPage')){
            selectedVariantsFromSessionStorage[2] = [];
            selectedVariantsFromSessionStorage[3] = [];
        }

        if(testActive){
            selectedVariantsFromSessionStorage[2] = [];
            selectedVariantsFromSessionStorage[3] = [];
        }

        if(presetAddons.length > 0 && !testActive){
            presetAddons.forEach((presetAddon) => {
                if (!selectedVariantsFromSessionStorage[2].some(
                    item => item.product_handle === presetAddon.product_handle
                )) {
                    selectedVariantsFromSessionStorage[2].push(presetAddon);
                }
            })
        }

        if(presetAccessories.length > 0 && !testActive){
            presetAccessories.forEach((presetAccessory) => {
                if (!selectedVariantsFromSessionStorage[3].some(
                    item => item.product_handle === presetAccessory.product_handle
                )) {
                    selectedVariantsFromSessionStorage[3].push(presetAccessory);
                }
            })
        }
    }
}

const correctSessionStorageOrder = function(sessionStorage){

    let sessionStorageInCorrectOrder = JSON.parse(JSON.stringify(sessionStorage));

    // Nothing saved in the first tab group → no first-handle to match against, so leave order as-is.
    if(!sessionStorageInCorrectOrder[0] || !sessionStorageInCorrectOrder[0][0]){
        return sessionStorageInCorrectOrder;
    }

    let firstItemHandle = sessionStorageInCorrectOrder[0][0]['product_handle'];
    let firstTabItems = document.querySelectorAll('.bundle-builder-form__tab')[0].querySelectorAll('.bundle-builder-form__product-container')
    let match = [...firstTabItems].some(item => item.dataset.productHandle === firstItemHandle);

    if(match == false){
        sessionStorageInCorrectOrder[0] = JSON.parse(JSON.stringify(sessionStorage[1]))
        sessionStorageInCorrectOrder[1] = JSON.parse(JSON.stringify(sessionStorage[0]))
    }

    return sessionStorageInCorrectOrder
}

/* Function that returns the index of a given element within its parent */
const getElementIndex = function(element) {
    if (!element || !element.parentNode) {
        return -1;
    }

    var children = element.parentNode.children;
    for (var i = 0; i < children.length; i++) {
        if (children[i] === element) {
            return i; 
        }
    }

    return -1; 
}

window.Branch = window.Branch || {};
window.Branch.bundle = window.Branch.bundle || {};




//add to cart logic based on simplistic
//shows the loading overlay before finding all data-variant-id from the summary after the builder is built
//there's also a custom property added to all products from the builder that will show in the orders
const addItemstoCart = function() {
    // If we're inside an open tingle modal (pdp-bundle popup), reparent the
    // loading overlay into the modal so it isn't stacked behind it
    // (tingle uses z-index: max-int, which #loading-overlay can't beat).
    const _addToCartTingleModal = document.querySelector('.tingle-modal.tingle-modal--visible');
    const _addToCartOverlay = document.getElementById('loading-overlay');
    if(_addToCartTingleModal && _addToCartOverlay && !_addToCartTingleModal.contains(_addToCartOverlay)){
        _addToCartTingleModal.appendChild(_addToCartOverlay);
    }
    $('#loading-overlay').show();
    const container = document.querySelector('.bundle-builder__summary-inner-container');
    const items = [];

    if (container) {        
        selectVariantsArray.forEach(selectVariantInnerArray => {
            if(selectVariantInnerArray.length > 0){
                selectVariantInnerArray.forEach((selectVariant) => {
                    const variantId = selectVariant['variant_id'];
                    if (variantId) {
                        let constituents = JSON.parse(variant_data[variantId][`constituents`].replace(/'/g, '"'));
                        if(constituents.length > 0){
                            constituents.forEach((constituent) => {
                                let variantId = `${constituent['variantId']}`;
                                items.push({
                                    id: variantId,
                                    quantity: constituent['quantity'],
                                    properties: {
                                        '_Branch': 'bundle_builder',
                                        '_ship_date': `${variant_data[variantId]['variant_msbd_string']}`
                                    }
                                }); 
                            })
                        } else {
                        items.push({
                            id: variantId,
                            quantity: 1,
                            properties: {
                                '_Branch': 'bundle_builder',
                                '_ship_date': `${selectVariant['variant_msbd_string']}`
                            }
                        });
                    }
                    }
                })
            }
        });

        if (items.length > 0) {
            const postRequest = function(variantId, itemQuantity, itemProperties, callback) {
                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        items: [{ id: variantId, quantity: itemQuantity, properties: itemProperties }]
                    })
                })
                .then(response => response.json())
                .then(data => {
                    if (callback) {
                        callback();
                    }
                })
                .catch(error => {
                    console.error('Error:', error);
                });
            }

            const addItem = function(queue, callback) {
                if (queue.length > 0) {
                    const item = queue.shift();
                    postRequest(item.id, item.quantity, item.properties, function() {
                        addItem(queue, callback);
                    });
                } else {
                    if (callback) {
                        callback();
                    }
                }
            }

            const updateCart = function() {
                let cartData = { updates: {}, attributes: {} };

                document.querySelectorAll('#side-cart form input[data-item-type="product"][data-quantity-input]').forEach((quantityInput) => {
                    const key = quantityInput.getAttribute('data-key');
                    const value = parseInt(quantityInput.value);
                    cartData.updates[key] = value;
                });

                cartData.attributes['order_tag'] = 'bundle-builder';
                //get the Clarity User ID and add it to the attributes
                const clarityId = getClarityUserId();
                if (clarityId) {
                    cartData.attributes['clarity_id'] = clarityId;
                }

                $.ajax({
                    type: 'POST',
                    url: '/cart/update.js',
                    data: cartData,
                    dataType: 'json'
                }).fail(function() {

                }).done(function() {
                    addToCartSuccess();
                    $('#loading-overlay').fadeOut(function(){
                        // Restore the overlay to <body> so subsequent non-modal
                        // uses (cart page, etc.) keep working normally.
                        if(this.parentElement !== document.body){
                            document.body.appendChild(this);
                        }
                    });
                    $('.bundle-builder__back-forward-button[data-direction="back"]').html('VIEW CART');
                    $('.bundle-builder__back-forward-button[data-direction="back"]').attr('data-direction','view_cart');
                    $('.bundle-builder__back-forward-button[data-direction="forward"]').html('CHECKOUT');
                    $('.bundle-builder__back-forward-button[data-direction="forward"]').attr('data-direction','checkout');
                    $('.bundle-builder-form__nav-button').each(function(){
                        $(this).attr('data-step-unlocked','false')
                    });
                    sessionStorage.removeItem("selectedBundleVariants")
                });
            }
            
            let queue = items.map(item => ({
                id: item.id,
                quantity: item.quantity,
                properties: item.properties
            }));

            addItem(queue, updateCart);
        } else {
            alert('No items to add to cart.');
        }
    } else {
        console.error('Container not found.');
    }
};

/* Function that receives an array of addons that are still comptatible with the current chair/desk selection
and checks whether the selected variant any of those addons needs to be updated  */
const updateFilteredAddons = function(tab_index, filteredAddons, initially_selected_variant_ids){
    let tempFilteredAddons = filteredAddons.map(obj => ({ ...obj }));
    let currentCompatibleAddons = [initially_selected_variant_ids[tab_index]]
            .flatMap(id => product_data[id].addon_handles.replace(/\s/g, '').split(','));
        let addOnsForNewProduct = tempFilteredAddons.filter(addon => currentCompatibleAddons.includes(addon.productHandle));
        let prevSelectedProduct = prevSelectedChairDesk[tab_index];

        if (addOnsForNewProduct.length > 0) {
            addOnsForNewProduct.forEach(addon => {
                removedButSavedAddonData[prevSelectedProduct].push(addon);

                let tab = tabs[tab_index];
                let currentProductContainer = tab.querySelector('.bundle-builder-form__product-container[data-selected="true"]');
                let currentProductId = parseInt(currentProductContainer.getAttribute('data-product-id'));
                let currentProductHandle = currentProductContainer.getAttribute('data-product-handle');
                let currentProductVariantId = parseInt(tab.querySelector('.bundle-builder-form__selected-product-variants-container input[name="id[]"]').value);
                let removedData = removedButSavedAddonData[currentProductId];
                let newProduct;

                if (removedData.length > 0) {
                    let index = removedData.findIndex(obj => obj.productHandle === currentProductHandle);
                    newProduct = index !== -1 ? bundlePricingDataArray.splice(index, 1)[0].productHandle : null;
                }

                if (!newProduct) {
                    let matchingVariant = window.Branch.product.returnMatchingVariantAddOn(variant_data[currentProductVariantId], addon.productHandle, findProductByHandle(products, addon.productHandle));

                    newProduct = {
                        productHandle: addon.productHandle,
                        variantId: matchingVariant.id,
                        quantity: 1
                    };
                }

                tempFilteredAddons = tempFilteredAddons.map(obj => obj.productHandle === addon.productHandle ? newProduct : obj);
            });
        }
    return tempFilteredAddons;
}

/* Function that updates the 'addons' tab on the basis of the selected desk and chair products */
const updateCompatibleAddons = function(tab_index, origin){

    // console.log('updateCompatibleAddons')

    /* Grab the compatible addons for the selected chair and desk products */
    let initially_selected_variant_ids = Array.from(document.querySelectorAll('.bundle-builder-form__tab[data-index="0"] .bundle-builder-form__product-container[data-selected="true"], .bundle-builder-form__tab[data-index="1"] .bundle-builder-form__product-container[data-selected="true"]')).map(el => parseInt(el.getAttribute('data-product-id')));
    if(selectedVariantsFromSessionStorage.length > 0 && origin == 'init'){

        if(selectedVariantsFromSessionStorage[0][0]) {
            initially_selected_variant_ids[0] = selectedVariantsFromSessionStorage[0][0]['product_id'];
        }

        if(selectedVariantsFromSessionStorage[1][0]) {
            initially_selected_variant_ids[1] = selectedVariantsFromSessionStorage[1][0]['product_id']
        }
    }    

    // console.log('initially_selected_variant_ids', initially_selected_variant_ids)

    current_compatible_addons = initially_selected_variant_ids.flatMap(id => {
    const handles = product_data[id]?.addon_handles;
    if (!handles) return [];
    return handles.replace(/\s/g, '').split(',').filter(Boolean);
    });

    /* Remove non-compatible addons from input, and update 'selectVariantsArray' variable */
    let input = document.querySelector(`.bundle-builder-form__tab[data-index="2"]`) ? document.querySelector(`.bundle-builder-form__tab[data-index="2"]`).querySelector('input.bundle-builder-form__addons-input') : null;
    if(input){
        if(origin == 'init' && selectedVariantsFromSessionStorage.length > 0 && input){
                if(selectedVariantsFromSessionStorage[2] && selectedVariantsFromSessionStorage[2].length > 0){
                    let onLoadInputValue = [];
                    selectedVariantsFromSessionStorage[2].forEach((prevSelectedAddon) => {
                        if(current_compatible_addons.includes(prevSelectedAddon['product_handle'])){
                            // console.log('here!')
                            onLoadInputValue.push({"productHandle": `"${prevSelectedAddon['product_handle']}"`, "variantId": `"${prevSelectedAddon['variant_id']}"`, "quantity": 1 })
                        }
                    });
                    input.value = onLoadInputValue;
                    input.setAttribute('value', JSON.stringify(onLoadInputValue));
                }
            }

            
            let addonsData = input && input.getAttribute('value') ? JSON.parse(`${input.getAttribute('value')}`) : [];

            if(addonsData.length > 0){
                let filteredAddons = addonsData.filter(addon => current_compatible_addons.includes(addon.productHandle));

                /* Make an array of the selected addons that have been removed */
                let removedSelectedAddons = addonsData.filter(addon => !current_compatible_addons.includes(addon.productHandle));

                /* Checks if either of the previous chair/desk products have any of the removed add ons as an add on, and if so stashes their value in the 'removedButSavedAddonData' object */
                if (removedSelectedAddons.length > 0) {
                    removedSelectedAddons.forEach(removedSelectedAddon => {
                        prevSelectedChairDesk.forEach(prevSelectedProduct => {
                            if (prevSelectedProduct) {
                                const selectedProductAddons = product_data[prevSelectedProduct]['addon_handles'].split(',');
                                if (selectedProductAddons.includes(removedSelectedAddon['productHandle'])) {
                                    removedButSavedAddonData[prevSelectedProduct].push(removedSelectedAddon);
                                }
                            }
                        });
                    });
                }

                /* Update filtered addons */
                if (tab_index >= 0 && tab_index < 2 && filteredAddons.length > 0) {
                    filteredAddons = updateFilteredAddons(tab_index, filteredAddons, initially_selected_variant_ids);
                }

                /* Overwrite filteredAddons if loading and previous addons were selected */
                if(selectedVariantsFromSessionStorage.length > 0 && origin == 'init'){
                    let onLoadInputValue = [];
                    selectedVariantsFromSessionStorage[2].forEach((prevSelectedAddon) => {
                        if(prevSelectedAddon['product_handle'] && current_compatible_addons.includes(prevSelectedAddon['product_handle']) && prevSelectedAddon['variant_id']){
                            onLoadInputValue.push({"productHandle": prevSelectedAddon['product_handle'], "variantId": `${prevSelectedAddon['variant_id']}`, "quantity": 1 })
                        }
                    });
                    filteredAddons = onLoadInputValue;
                }

                /* Update input and 'selectVariantsArray' */
                if(filteredAddons.length > 0){
                    input.value = JSON.stringify(filteredAddons);
                    input.setAttribute('value', JSON.stringify(filteredAddons));
                    if(origin == 'init' && selectedVariantsFromSessionStorage.length > 0) {
                        selectVariantsArray[2] = JSON.parse(JSON.stringify(selectedVariantsFromSessionStorage[2]));
                    } else {
                        selectVariantsArray[2] = filteredAddons;
                    }
                } else {
                    input.value = '';
                    input.setAttribute('value', ''); 
                    selectVariantsArray[2] = [];
                }
                saveSelectedVariantsToLocalStorage();

                addonsCheck();
            }
    }
    // console.log('current_compatible_addons', current_compatible_addons)


}

/* Function that updates the 'accessories' tab on the basis of the selected desk and chair products */
const updateCompatibleAccessories = function(tab_index, origin){
    /* Grab the compatible accessories for the selected chair and desk products */
    let initially_selected_variant_ids = Array.from(document.querySelectorAll('.bundle-builder-form__tab[data-index="0"] .bundle-builder-form__product-container[data-selected="true"], .bundle-builder-form__tab[data-index="1"] .bundle-builder-form__product-container[data-selected="true"]')).map(el => parseInt(el.getAttribute('data-product-id')));
    if(selectedVariantsFromSessionStorage.length > 0 && origin == 'init'){
        if(selectedVariantsFromSessionStorage[0][0]) {
            initially_selected_variant_ids[0] = selectedVariantsFromSessionStorage[0][0]['product_id'];
        }

        if(selectedVariantsFromSessionStorage[1][0]) {
            initially_selected_variant_ids[1] = selectedVariantsFromSessionStorage[1][0]['product_id']
        }
    }


    current_compatible_accessories = initially_selected_variant_ids.flatMap(id => {
        const handles = product_data[id]?.addon_handles;
        if (!handles) return [];
        return handles.replace(/\s/g, '').split(',').filter(Boolean);
    });

    /* Remove non-compatible accessories from input, and update 'selectVariantsArray' variable */
    let input = document.querySelector(`.bundle-builder-form__tab[data-index="3"]`) ? document.querySelector(`.bundle-builder-form__tab[data-index="3"]`).querySelector('input.bundle-builder-form__addons-input') : null;

    if(input){
        if(origin == 'init' && selectedVariantsFromSessionStorage.length > 0 && input){
                if(selectedVariantsFromSessionStorage[3] && selectedVariantsFromSessionStorage[3].length > 0){
                    let onLoadInputValue = [];
                    selectedVariantsFromSessionStorage[3].forEach((prevSelectedAccessory) => {
                        if(current_compatible_accessories.includes(prevSelectedAccessory['product_handle'])){
                            onLoadInputValue.push({"productHandle": `"${prevSelectedAccessory['product_handle']}"`, "variantId": `"${prevSelectedAccessory['variant_id']}"`, "quantity": 1 })
                        }
                    });
                    input.value = onLoadInputValue;
                    input.setAttribute('value', JSON.stringify(onLoadInputValue));
                }
            }


            let accessoriesData = input && input.getAttribute('value') ? JSON.parse(`${input.getAttribute('value')}`) : [];

            if(accessoriesData.length > 0){
                let filteredAccessories = accessoriesData.filter(accessory => current_compatible_accessories.includes(accessory.productHandle));

                /* Make an array of the selected accessories that have been removed */
                let removedSelectedAccessories = accessoriesData.filter(accessory => !current_compatible_accessories.includes(accessory.productHandle));

                /* Checks if either of the previous chair/desk products have any of the removed accessories as an add on, and if so stashes their value in the 'removedButSavedAddonData' object */
                if (removedSelectedAccessories.length > 0) {
                    removedSelectedAccessories.forEach(removedSelectedAccessory => {
                        prevSelectedChairDesk.forEach(prevSelectedProduct => {
                            if (prevSelectedProduct) {
                                const selectedProductAddons = product_data[prevSelectedProduct]['addon_handles'].split(',');
                                if (selectedProductAddons.includes(removedSelectedAccessory['productHandle'])) {
                                    removedButSavedAddonData[prevSelectedProduct].push(removedSelectedAccessory);
                                }
                            }
                        });
                    });
                }

                /* Update filtered accessories */
                if (tab_index >= 0 && tab_index < 2 && filteredAccessories.length > 0) {
                    filteredAccessories = updateFilteredAddons(tab_index, filteredAccessories, initially_selected_variant_ids);
                }

                /* Overwrite filteredAccessories if loading and previous accessories were selected */
                if(selectedVariantsFromSessionStorage.length > 0 && origin == 'init'){
                    let onLoadInputValue = [];
                    selectedVariantsFromSessionStorage[3].forEach((prevSelectedAccessory) => {
                        if(prevSelectedAccessory['product_handle'] && current_compatible_accessories.includes(prevSelectedAccessory['product_handle']) && prevSelectedAccessory['variant_id']){
                            onLoadInputValue.push({"productHandle": prevSelectedAccessory['product_handle'], "variantId": `${prevSelectedAccessory['variant_id']}`, "quantity": 1 })
                        }
                    });
                    filteredAccessories = onLoadInputValue;
                }

                /* Update input and 'selectVariantsArray' */
                if(filteredAccessories.length > 0){
                    input.value = JSON.stringify(filteredAccessories);
                    input.setAttribute('value', JSON.stringify(filteredAccessories));
                    if(origin == 'init' && selectedVariantsFromSessionStorage.length > 0) {
                        selectVariantsArray[3] = JSON.parse(JSON.stringify(selectedVariantsFromSessionStorage[3]));
                    } else {
                        selectVariantsArray[3] = filteredAccessories;
                    }
                } else {
                    input.value = '';
                    input.setAttribute('value', '');
                    selectVariantsArray[3] = [];
                }
                saveSelectedVariantsToLocalStorage();

                addonsCheck();
            }
    }
}

/* Function that checks whether the current chair/desk product have saved add-on products to re-add, and re-adds them if so */
const reAddRemovedButSavedAddons = function(){
    let addonReAdded = false;
    
    for (var i = 0; i < 2; i++) {
       let chairDeskId = parseInt(selectVariantsArray[i][0]['product_id']);
 
       if(removedButSavedAddonData[`${chairDeskId}`].length > 0){
        removedButSavedAddonData[`${chairDeskId}`].forEach((removedButSavedAddon) => {
            updateAddons('add', removedButSavedAddon, 2, removedButSavedAddon['productId']);
            addonReAdded = true
        })
        removedButSavedAddonData[`${chairDeskId}`] = [];
       }
    }

    if(addonReAdded == true){
        addonsCheck();
        window.Branch.bundle.updatePricing();
        window.Branch.bundle.updateGalleryImage();
        window.Branch.bundle.updateSummaryTab();
        window.Branch.bundle.updateCTAURLParams();
    }
    saveSelectedVariantsToLocalStorage();
}

/* Toggle active-campaign-promo-style="true" on the immediate-child span of
   each .bundle-builder-price__savings-label-outer-container when a campaign
   is active with enable_promo_styling = true AND the priceParent currently
   has data-display-regular-message="false" (i.e. a bundle discount message
   is being shown). The caller may pass a pre-queried NodeList of priceParents
   to avoid an extra DOM query. */
function applyBundleBuilderSavingsLabelPromoStyle(priceParents){
    if(!priceParents) priceParents = document.querySelectorAll('.bundle-builder-price__savings-label-outer-container');
    if(priceParents.length === 0) return;

    let data = (typeof discountCodeData !== 'undefined' && discountCodeData)
        ? discountCodeData
        : (document.querySelector('#discount-code-data') ? JSON.parse(document.querySelector('#discount-code-data').innerText) : null);

    let anyCampaignPromoStyle = false;
    let anyCampaignSwatchDefault = false;
    if(data){
        for(let i = 1; i <= 2; i++){
            if(!data['active_campaign_' + i + '_is_active']) continue;
            if(data['active_campaign_' + i + '_enable_promo_styling']) anyCampaignPromoStyle = true;
            if(data['active_campaign_' + i + '_swatch_default_color']) anyCampaignSwatchDefault = true;
        }
    }

    priceParents.forEach((priceParent) => {
        let targetSpan = priceParent.querySelector(':scope > span');
        if(!targetSpan) return;
        let regularMessageHidden = priceParent.getAttribute('data-display-regular-message') === 'false';
        if(anyCampaignPromoStyle){
            targetSpan.setAttribute('active-campaign-promo-style', 'true');
            targetSpan.setAttribute('active-campaign-promo-type', 'discount_swatches');

        } else {
            targetSpan.removeAttribute('active-campaign-promo-style');
            targetSpan.removeAttribute('active-campaign-promo-type');
        }
        if(anyCampaignSwatchDefault){
            targetSpan.setAttribute('data-display-active-campaign-swatch-background', 'true');
        } else {
            targetSpan.removeAttribute('data-display-active-campaign-swatch-background');
        }
        priceParent.setAttribute('data-initialized', 'true');
    });
}

/* Function that updates the title and subtitle text depending on what collection tab is currently selected */
const hideShowSliderTitleSubtitle = function(summaryTab){
    let selectedCollectionHeaderText = collectionHeaderText[step - 1];
    if(navSubTitleContainers.length > 0){
        navSubTitleContainers.forEach((navSubTitleContainer) => {
            navSubTitleContainer.setAttribute('data-showing', false);
            navSubTitleContainer.setAttribute('aria-hidden', true);
        });

        if(summaryTab == false){
            let selectedNavSubTitleContainer = navSubTitleContainers[step - 1];
            if(selectedNavSubTitleContainer){
                selectedNavSubTitleContainer.setAttribute('data-showing', true);
                selectedNavSubTitleContainer.setAttribute('aria-hidden', false);
            }
        }
    }

    if(selectedCollectionHeaderText){
        navTitleContainer.innerHTML = selectedCollectionHeaderText;
    }
}

/* Inverted anchor to be used (mobile only) when changing between sections of the builder (chair,desk,etc) */
function bundleScrollToSectionEnd(element) {
    if (element) {
        var sectionBottom = element.offsetTop + element.offsetHeight;
        var viewportHeight = window.innerHeight;

        // Scroll (smooth) to the bottom of the section
        window.scrollTo({
            top: sectionBottom - viewportHeight,
            behavior: 'smooth'
        });
    }
}

/* Function which triggers the inverted anchor when width is up to 899px */
function checkAndScroll() {
    if (window.innerWidth <= 899) {
        setTimeout(function() {
            var elements = document.getElementsByClassName('bundle-builder__info-outer-container');
            if (elements.length > 0) {
                bundleScrollToSectionEnd(elements[0]);
            }
        }, 200);
    }
}

//inverted anchor to be used (mobile only) when changing between sections of the builder (chair,desk,etc)
function bundleScrollToSectionEnd(element) {
    if (element) {
        var sectionBottom = element.offsetTop + element.offsetHeight;
        var viewportHeight = window.innerHeight;

        // Scroll (smooth) to the bottom of the section
        window.scrollTo({
            top: sectionBottom - viewportHeight,
            behavior: 'smooth'
        });
    }
}

// When width is up to 899px, the function will trigger the inverted anchor
function checkAndScroll() {
    if (window.innerWidth <= 899) {
        setTimeout(function() {
            var elements = document.getElementsByClassName('bundle-builder__info-outer-container');
            if (elements.length > 0) {
                bundleScrollToSectionEnd(elements[0]); // Assuming you want to scroll to the first matched element
            }
        }, 200);
    }
}

/* Function which shows/hide the collection tabs depending on what's been selected */
const showCollection = function(collectionId, summaryTab, type) {
    let amount_completed = 0;

    if(navButtons[step] && navButtons[step].getAttribute('data-step-unlocked') == "false"){
        navButtons[step].setAttribute('data-step-unlocked', true)
    }

    tabs.forEach((tab) => {
        tab.setAttribute('data-showing', false);
        tab.setAttribute('aria-hidden', true);
    });

    navButtons.forEach((button) => {
        button.setAttribute('data-active', false);
        button.setAttribute('data-completed', false);
    });

    navLineSections.forEach((lineSection) => {
        lineSection.setAttribute('data-active', false);
    });

    formContainer.setAttribute('data-summary-tab', summaryTab)
    // Show the selected collection
    const selectedCollection = tabs[step - 1];

    if (selectedCollection) {
        selectedCollection.setAttribute('data-showing', true);
        selectedCollection.setAttribute('aria-hidden', false);
        hideShowSliderTitleSubtitle(summaryTab);

        // Find the button that matches the collectionId and add the active class
        let selectedCollectionButton = navButtons[step - 1];

        selectedCollectionButton.setAttribute('data-active', true);

        let selectedCollectionButtonPreviousSiblings = Array.from(selectedCollectionButton.parentNode.children).slice(0, Array.from(selectedCollectionButton.parentNode.children).indexOf(selectedCollectionButton));
        
        if (selectedCollectionButtonPreviousSiblings.length > 0) {
            selectedCollectionButtonPreviousSiblings.forEach((selectedCollectionButtonPreviousSibling) => {
                selectedCollectionButtonPreviousSibling.setAttribute('data-completed', true);
                amount_completed = amount_completed + 1;
            });
        };
        if (selectedCollectionButton.id === "bundle-builder-form__nav-button--fifth" && selectedCollectionButton.getAttribute('data-active') === "true") {
            selectedCollectionButton.setAttribute('data-completed', true);
            selectedCollectionButton.setAttribute('data-active', true);
            navLineSections[1].style.width = `100%`
        }else {
            navLineSections[1].style.width = `${((((tabs.length - 1) * 2)) / (((tabs.length - 1) * 2) + 1) * 100)}%`
        }

        if(amount_completed == (tabs.length - 1)){
            navLineSections[1].style.transform = `scaleX(1)`
        } else if(amount_completed > 0){
            navLineSections[1].style.transform = `scaleX(${((amount_completed * 2) / ((tabs.length * 2) - 1))})`
        } else {
            navLineSections[1].style.transform = `scaleX(0)`
        }

        let productsInCollection = selectedCollection.querySelectorAll(`.bundle-builder-form__product-container`);
        let selectedProductIndex = selectedCollection.getAttribute('data-selected-index') ? parseInt(selectedCollection.getAttribute('data-selected-index')) : 0;
       


        // console.log('productsInCollection', productsInCollection);
        // console.log('selectedProductIndex', selectedProductIndex);
        let updateProduct = Array.from(productsInCollection).find(
            product => product.getAttribute('data-product-index') == selectedProductIndex
          );
        // if(type == 'first'){updateProduct = productsInCollection[0]};

        // console.log('updateProduct', updateProduct);
        // console.log('type', type)

        if(summaryTab == false){
            updateVariantDataOnClick(updateProduct, collectionId, type);
        }

       updateBackForwardButtons();
    }

    backForwardButtonsContainer.setAttribute('data-disabled', false);

    adjustStickyTop();
}

/* Function that initializes the on-click event listeners on each of the nav buttons */
const initNavButtonListeners = function() {
    navButtons.forEach((button, index) => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            const collectionId = order_string_array[parseInt(this.getAttribute('data-index'))];
            let summaryTab = (index + 1) == navButtons.length ? true : false;

            formContainer.setAttribute('data-step', index + 1);
            bundleBuilderContainer.setAttribute('data-step', index + 1);
            step = index + 1;            
            showCollection(collectionId, summaryTab, 'click');
        });
    });

    // Initially hide all collections except the first one and mark the first button as active
    showCollection(null, false, 'first');
}

const returnSpecialConditionUrl = function(variantImageUrl, variantImageUrlSelected){
    let specialConditionURL = variantImageUrlSelected;
    if(variantImageUrl['special-conditions'] && variantImageUrl['special-conditions'].length > 0){
        variantImageUrl['special-conditions'].forEach((specialCondition) => {
            let selectedChairDeskProducts = [selectVariantsArray[0][0], selectVariantsArray[1][0]];
            selectedChairDeskProducts.forEach((selectedChairDesk) => {
                if(specialCondition['main-product-handle'] == selectedChairDesk['product_handle']){
                    specialConditionURL = specialCondition['default-image-url'];
                    if(specialCondition['option-matches'] && specialCondition['option-matches'].length > 0){
                        specialCondition['option-matches'].forEach((optionMatch) => {
                            let selectedProductOptions = JSON.parse(selectedChairDesk.options.replaceAll(`'`, `"`));
                            if(selectedProductOptions && selectedProductOptions[`${optionMatch["main-product-option-name"]}`] == optionMatch["main-product-option-value"]){
                                specialConditionURL = optionMatch["image-url"]
                            }

                        })
                    }
                }
            })
        })
    }
    return specialConditionURL;
}

/* Function that updates the layover images */
window.Branch.bundle.updateGalleryImage = function() {
    selectVariantsArray.forEach((selectVariantSubArray, tab_loop_index) => {
        let mainImageContainer = mainImageContainers[tab_loop_index];
        let images = mainImageContainer.querySelectorAll('img');
        let need_to_update = selectVariantSubArray.length !== images.length;
        let currentImageVariantIds = [];
        const image_type = [collectionTypeArray[0], collectionTypeArray[1], 'addons'][tab_loop_index] || 'other';

        if (images.length > 0) {
            currentImageVariantIds = Array.from(images).map(img => img.getAttribute('data-variant-id')).sort();
        }

        if (selectVariantSubArray.length > 0 && !need_to_update) {
            let updatedImageVariantIds = selectVariantSubArray.flat().map(variant => variant.variant_id).sort((a, b) => a - b);
            need_to_update = arraysMatch(updatedImageVariantIds, currentImageVariantIds);
        }

        if (need_to_update) {
            mainImageContainer.innerHTML = '';
            let imageAppended = false;
            selectVariantSubArray.forEach((selectVariant) => {
                let { bundle_builder_image: variantImageUrl, variant_title: variantImageAlt, variant_id: variantId } = selectVariant;
                let imageFileName = variantImageUrl.default ? variantImageUrl.default.split('/').pop().split('?')[0] : variantImageUrl.split('/').pop().split('?')[0];
                let variantImageUrlSelected = variantImageUrl.default ? variantImageUrl.default : variantImageUrl;
                if(image_type == 'addons'){
                    variantImageUrlSelected = returnSpecialConditionUrl(variantImageUrl, variantImageUrlSelected)
                    imageFileName = variantImageUrlSelected.split('/').pop().split('?')[0];

                }

                // Call composite image function and ensure it completes (use bundle builder layers)
                let compositeImageReplacementFound = false;
                try {
                    compositeImageReplacementFound = window.Branch.compositeRenderImage.initRenderImagesForBundleBuilder(selectVariant, mainImageContainer, true);
                    // console.log('Composite image function returned:', compositeImageReplacementFound, 'for variant:', selectVariant.variant_id);
                } catch (error) {
                    console.error('Error in composite image function:', error);
                    compositeImageReplacementFound = false;
                }

                if(compositeImageReplacementFound === true){
                    imageAppended = true;
                } else {
                    if (imageFileName === 'bundle-builder-options-error.webp' && imageAppended) return;

                    let newImage = document.createElement("img");
                    newImage.setAttribute('width', 540);
                    newImage.setAttribute('height', 540);
                    newImage.setAttribute('data-variant-id', variantId);
                    newImage.setAttribute('sizes', "(max-width: 900px) 100vw, (max-width: 1167px) calc(100vw - 538px), calc((100vw - 84px) * 0.55)");
                    newImage.setAttribute('alt', variantImageAlt);
                    newImage.setAttribute('srcset', `${variantImageUrlSelected}&width=180 180w, ${variantImageUrlSelected}&width=360 360w, ${variantImageUrlSelected}&width=540 540w, ${variantImageUrlSelected}&width=720 720w, ${variantImageUrlSelected}&width=900 900w, ${variantImageUrlSelected}&width=1080 1080w, ${variantImageUrlSelected}&width=1280 1280w, ${variantImageUrlSelected}&width=1440 1440w, ${variantImageUrlSelected} 2100w`);
                    newImage.classList.add('bundle-builder-gallery__image', `${image_type}`);

                    mainImageContainer.appendChild(newImage);

                    if (imageFileName === 'bundle-builder-options-error.webp') {
                        imageAppended = true;
                    }
                }
            });
        }
    });

    updateCarouselImages();
};

const updateVariantDataOnClick = function(product, collectionId, interaction_type, specialIndex, selectedVariantFromSessionStorage) {
    if(standInSwatchesRemoved == false){
        let standInSwatches = document.querySelector('.bundle-builder-form__stand-in-swatches');
        standInSwatches.remove();
        standInSwatchesRemoved = true;
    }

    let currentStep = step;
    if(interaction_type == 'init'){
        currentStep = specialIndex;
    }

    let bundleVariants = selectedProductVariantsContainers[currentStep - 1];
    let sameProduct = false;

    // console.log('product', product)

    if(bundleVariants && bundleVariants.querySelector('.bundle-builder-form__product-variants-inner-container')){
        sameProduct = bundleVariants.querySelector('.bundle-builder-form__product-variants-inner-container').getAttribute('data-product-handle') == product.getAttribute('data-product-handle');
    }

    if(currentStep < 3 && sameProduct == false && currentStep != total_steps){
        let currentTabProducts = productContainersInEachTab[currentStep - 1];

        currentTabProducts.forEach((p) => {
            p.setAttribute('data-selected', false);
        });

        let emptiedVariantsContainer = product.closest('.bundle-builder-form__tab').querySelector('.bundle-builder-form__product-variants-container[data-emptied="true"]');
        if (emptiedVariantsContainer) {
            let bundleVariantsInnerHTML = bundleVariants.innerHTML;
            emptiedVariantsContainer.innerHTML = bundleVariantsInnerHTML;
            emptiedVariantsContainer.setAttribute('data-emptied', false);
        }


        // Add 'selected' class to the clicked product
        product.setAttribute('data-selected', true);

        // Get the variants of the selected product
        let productVariantsContainer = product.querySelector('.bundle-builder-form__product-variants-container');
        let variantsContainerInnerHTML = productVariantsContainer.innerHTML;
       
        productVariantsContainer.setAttribute('data-emptied', true);
        productVariantsContainer.innerHTML = "";

        // Render the variants in the bundle-variants container
        bundleVariants.innerHTML = variantsContainerInnerHTML;

        let productId = parseInt(product.getAttribute('data-product-id'));
        let currentProduct = products.find(product => product.id === productId);

        if(currentStep < 3){
            linkOptionSelectorsInit(currentProduct);
            if(selectedVariantFromSessionStorage){
                let swatchesContainer = tabs[currentStep - 1].querySelector('.bundle-builder-form__selected-product-variants-container');
                let selectElement = swatchesContainer.querySelector(`.select-variant`)
                let optionToSelect = selectElement.querySelector(`option[data-variant-id="${selectedVariantFromSessionStorage['variant_id']}"]`)

                if (optionToSelect) {
                    selectElement.value = `${parseInt(selectedVariantFromSessionStorage['variant_id'])}`;
                    selectElement.setAttribute('value', parseInt(selectedVariantFromSessionStorage['variant_id']));
                    selectElement.dispatchEvent(new Event('change', { bubbles: true }));
                  }

                if(interaction_type == "init"){
                    tabs[currentStep - 1].setAttribute('data-selected-index', selectedVariantFromSessionStorage['index_in_collection']);
                }
            }
        }
    } 



    // Update variant image on variant change

    if(currentStep < 3 && sameProduct == false){
        updateProductOneLineDescription(currentStep - 1, product.getAttribute('data-product-id'))
    }

    // Trigger background image loading

    if(all_images_preloaded == false && interaction_type == 'click'){
        window.Branch.bundle.bundleBuilderPreloadImages('click');
        all_images_preloaded = true;
    }

    if(currentStep < 3 && sameProduct == false){
        let variantId = parseInt(bundleVariants.querySelector('input[name="id[]"]').value);
        let selectElement = document.querySelector(`.bundle-builder-form__product-variants-inner-container[data-product-handle="${product.getAttribute('data-product-handle')}"] select.select-variant`);
        let optionToSelect = selectElement.querySelector(`option[value='${variantId}']`);

        if (optionToSelect) {
            selectElement.value = variantId;
            selectElement.setAttribute('value', variantId);
            selectElement.dispatchEvent(new Event('change', { bubbles: true }));
          }

        // Check for addons to hide when this desk/chair variant is selected
        let productId = product.getAttribute('data-product-id');
        let variantData = variant_data[variantId];
        if (variantData) {
            let selected_product_data = products.find(product => product.id === parseInt(productId));
            setTimeout(() => {
                checkAddonsToHideForVariant(productId, variantData, selected_product_data);
            }, 500);
        }
    }

    let firstButtons = document.querySelectorAll(`.bundle-builder-form .bundle-builder-form__selected-product-variants-container .swatches-container .swatches-container__tab-outer-container[data-status="closed"] .swatches-container__tab-button[data-clickable="true"][data-first="true"]`);
    
    firstButtons.forEach((firstButton) => {
        const event = new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
        });
        firstButton.dispatchEvent(event);
    })
    window.Branch.product.updateSwatchRows('.bundle-builder__item');
    window.Branch.product.customSwatchContainerResize(`.bundle-builder-form`);
}

const initProductEventListener = function() {
    let products = document.querySelectorAll('.bundle-builder-form__tab[data-index="0"] .bundle-builder-form__product-container, .bundle-builder-form__tab[data-index="1"] .bundle-builder-form__product-container');
    products.forEach((product) => {
        product.addEventListener('click', function () {
            let activeTab = document.querySelector('.bundle-builder-form__tab[data-showing="true"]');
            let collectionId = activeTab.getAttribute('id');
            let product_index = getElementIndex(product);
            let tab_index = order_string_array.findIndex(element => element === collectionId);

            if(tab_index < 2){
                activeTab.setAttribute('data-selected-index', parseInt(product.getAttribute('data-product-index')));
            }

            /* Update the previously selected chair or desk product array */
            if(tab_index == 0 && prevSelectedChairDesk[0] != selectVariantsArray[0][0]['product_id']) {
                prevSelectedChairDesk[0] = selectVariantsArray[0][0]['product_id']
            } else if (tab_index == 1 && prevSelectedChairDesk[1] != selectVariantsArray[1][0]['product_id']){
                prevSelectedChairDesk[1] = selectVariantsArray[1][0]['product_id']
            }

            updateVariantDataOnClick(product, collectionId, 'click');
            updateCompatibleAddons(tab_index, 'on-click');
            updateCompatibleAccessories(tab_index, 'on-click');
            hideShowAddons();
            window.Branch.bundle.updatePricing();
            window.Branch.bundle.updateGalleryImage();
            window.Branch.bundle.updateCTAURLParams();
            window.Branch.bundle.updateSummaryTab();
            window.Branch.bundle.secondaryGalleryImages();
            reAddRemovedButSavedAddons();
        });
    });

    /* Select first available variant in first tab on load */
    let firstActiveTab = document.querySelector('.bundle-builder-form__tab[data-showing="true"]');

    if (firstActiveTab) {
        let firstProduct = document.querySelectorAll(`.bundle-builder-form__tab#${firstActiveTab.id} .bundle-builder-form__product-container`)[0];
        let selectedVariantFromSessionStorage1 = undefined;
        if(selectedVariantsFromSessionStorage.length > 0 && selectedVariantsFromSessionStorage[0][0]){
            firstProduct = document.querySelector(`.bundle-builder-form__tab#${firstActiveTab.id} .bundle-builder-form__product-container[data-product-id="${selectedVariantsFromSessionStorage[0][0]['product_id']}"]`);
            selectedVariantFromSessionStorage1 = selectedVariantsFromSessionStorage[0][0]

        }

        updateVariantDataOnClick(firstProduct, firstActiveTab.id, 'init', 1, selectedVariantFromSessionStorage1);
    }

    /* Select first available variant in second tab on load */
    let secondActiveTab = document.querySelector('.bundle-builder-form__tab[data-showing="true"] + .bundle-builder-form__tab:not(.bundle-builder-form__tab--summary)')

    if(secondActiveTab){
        let secondProduct = document.querySelectorAll(`.bundle-builder-form__tab#${secondActiveTab.id} .bundle-builder-form__product-container`)[0];
        let selectedVariantFromSessionStorage2 = undefined;
        if(selectedVariantsFromSessionStorage.length > 0 && selectedVariantsFromSessionStorage[1][0]){
            secondProduct = document.querySelector(`.bundle-builder-form__tab#${secondActiveTab.id} .bundle-builder-form__product-container[data-product-id="${selectedVariantsFromSessionStorage[1][0]['product_id']}"]`);
            selectedVariantFromSessionStorage2 = selectedVariantsFromSessionStorage[1][0]
        }
        
        updateVariantDataOnClick(secondProduct, secondActiveTab.id, 'init', 2, selectedVariantFromSessionStorage2);
    }
}

const returnSwiperOptions = function(tab_index) {
    let swiperOptions = {
        slidesPerView: 2.25,
        spaceBetween: 12,
        threshold: 10,
        navigation: {
            nextEl: `.bundle-builder-form__tab[data-index="${tab_index}"] .bundle-builder-form__slider-nav-right.swiper-button-next`,
            prevEl: `.bundle-builder-form__tab[data-index="${tab_index}"] .bundle-builder-form__slider-nav-left.swiper-button-prev`,
        },
        breakpoints: {
            600: {
                slidesPerView: 3.25,
                spaceBetween: 12,
                navigation: {
                    nextEl: `.bundle-builder-form__tab[data-index="${tab_index}"] .bundle-builder-form__slider-nav-right.swiper-button-next`,
                    prevEl: `.bundle-builder-form__tab[data-index="${tab_index}"] .bundle-builder-form__slider-nav-left.swiper-button-prev`,
                }
            }
        },
        on: {
            touchStart: function (swiper, event) {
                this.touchStartX = event.clientX;
                this.touchStartY = event.clientY;
              },
              touchEnd: function (swiper, event) {
                var touchEndX = event.clientX;
                var touchEndY = event.clientY;
                var diffX = Math.abs(touchEndX - this.touchStartX);
                var diffY = Math.abs(touchEndY - this.touchStartY);

                if (diffX >= this.params.threshold || diffY >= this.params.threshold) {
                  event.preventDefault();
                  this.allowSlideNext = true;
                  this.allowSlidePrev = true;
                }
              },
        }
    }
    return swiperOptions
}

const initProductsSlider = function() {
    // Swiper lazy-load guard: on product templates (including bundle products)
    // Swiper is deferred until user interaction or IntersectionObserver.
    // Without this guard, bundle pages throw "Uncaught ReferenceError: Swiper
    // is not defined" and the bundle builder UI is broken.
    if (typeof window.Swiper === 'undefined') {
        if (typeof window.whenSwiperReady === 'function') {
            window.whenSwiperReady(function(){ initProductsSlider(); });
        }
        return;
    }
    if (tabs.length > 0) {
        tabs.forEach((tab, tab_index) => {
            let swiper_options = returnSwiperOptions(tab_index)
            var bundleBuilderProductSwiper = new Swiper(tab.querySelector(`.bundle-builder-form__products-list-container`), swiper_options);
            bundle_builder_swipers.push(bundleBuilderProductSwiper);
            if(tab_index < 2 && selectVariantsArray[tab_index] && selectVariantsArray[tab_index][0]){
                let indexToSwipeTo = [...tab.querySelectorAll('.bundle-builder-form__product-container')].findIndex(el => el.dataset.productHandle === selectVariantsArray[tab_index][0]['product_handle']);
                if(indexToSwipeTo > 1){
                    bundleBuilderProductSwiper.slideTo(indexToSwipeTo + 2, 250)
                };
            }
        });
    }
}

const returnVariantSelectObject = function() {
    let variantSelectObject = {};
    variantSelectObject['onClickSelector'] = '.bundle-builder-form .swatch-element label';
    variantSelectObject['swatchesContainerSelector'] = '.bundle-builder-form__product-variants-inner-container';
    variantSelectObject['swatchUnitsSelector'] = '.bundle-builder-form__product-variants-inner-container[data-product-handle="##PRODUCT_HANDLE##"] .swatches-container .swatch';

    return variantSelectObject;
}

const selectFirstAvailableVariant = function() {
    let productContainers = document.querySelectorAll('.bundle-builder-form .bundle-builder-form__product-container');
    if (productContainers.length > 0) {
        productContainers.forEach((productContainer) => {
            let productHandle = productContainer.getAttribute('data-product-handle');
            let productId = parseInt(productContainer.getAttribute('data-product-id'));
            let selected_product_data = products.find(product => product.id === productId);
            let selected_variant = selected_product_data.variants.find(variant => variant.available === true);
            let productInputs = document.querySelectorAll(`.bundle-builder-form__product-variants-inner-container[data-product-handle="${productHandle}"] input[type=radio]`)
            let selectInput = document.querySelector(`.bundle-builder-form__product-variants-inner-container[data-product-handle="${productHandle}"] input#product-${productId}-variant`);
            let productSelector = `.bundle-builder-form__product-variants-inner-container[data-product-handle="${productHandle}"]`;

            // console.log('productHandle', productHandle);
            // console.log('selected_product_data', selected_product_data)

            if(!selected_variant){
                selected_variant = selected_product_data.variants[0]
            }

            // console.log('selected_product_data', selected_product_data)

            selectedVariantsFromSessionStorage.forEach((prevSelectedVariantArray) => {
                    if(prevSelectedVariantArray.length > 0){
                        prevSelectedVariantArray.forEach((prevSelectedVariant) => {
                            if(productHandle == prevSelectedVariant['product_handle']){

                                // console.log('var_id', parseInt(prevSelectedVariant['variant_id']))
                                selected_variant = selected_product_data.variants.find(variant => variant.id === parseInt(prevSelectedVariant['variant_id']));
                            }
                        })
                    }
                }) 

                // console.log('selected_product_data', selected_product_data)
                // console.log('selected_variant!!', selected_variant)

            window.Branch.product.selectVariantOnLoad(productId, selected_variant, productInputs, selectInput, productSelector, 'bundle-builder-form', selected_product_data, bundlePricingDataArray);

            let mainProductSwatches = document.querySelectorAll(`.bundle-builder-form__product-variants-inner-container[data-product-handle="${productHandle}"] .swatch`);
            window.Branch.product.updateVariantSwatchTitles(mainProductSwatches, selected_variant, productId);

            // Check for addons to hide when desk/chair variant is selected on load
            let variantDataForCheck = variant_data[selected_variant.id];
            if(variantDataForCheck && (variantDataForCheck.collection === 'chairs' || variantDataForCheck.collection === 'desks')) {
                checkAddonsToHideForVariant(productId.toString(), variantDataForCheck, selected_product_data);
            }

        });
    }
}

const returnSelectVariantsArray = function(){
    let tempSelectVariantsArray = [];
    for (let i = 0; i < total_steps - 1; i++) {
        let selectVariantsSubArray = [];
        let input = document.querySelector(`.bundle-builder-form__tab[data-index="${i}"] .bundle-builder-form__selected-product-variants-container input[name="id[]"]`)
        if(i < 2){
            let variant_id = document.querySelector(`.bundle-builder-form__tab[data-index="${i}"] .bundle-builder-form__selected-product-variants-container .select-variant`).value;
            let current_variant_data = variant_data[`${variant_id}`];
            current_variant_data['variant_id'] = variant_id
            current_variant_data['product_handle'] = input.closest('.bundle-builder-form__selected-product-variants-container').querySelector('.select-variant').getAttribute('data-handle');
            selectVariantsSubArray.push(current_variant_data)
            tempSelectVariantsArray.push(selectVariantsSubArray);
        } else {
            let addonsData = input.getAttribute('value') ? JSON.parse(`${input.getAttribute('value')}`) : [];
            if(addonsData.length > 0){
                addonsData.forEach((data_line) => {
                    let quantity = parseInt(data_line['quantity']);
                    Array(quantity).fill().forEach(() => {
                        let variant_id = parseInt(data_line['variantId']);
                        let current_variant_data = variant_data[`${variant_id}`];

                        current_variant_data['product_handle'] = data_line['productHandle'];
                        current_variant_data['variant_id'] = variant_id
                        selectVariantsSubArray.push(current_variant_data);
                    });
                })
            }
            tempSelectVariantsArray.push(selectVariantsSubArray);
        }
    }
    let deepCopy = JSON.parse(JSON.stringify(tempSelectVariantsArray));
    return deepCopy;
}

const returnBundlePricing = function(){
    bundlePricing = {};

    bundlePricing['bundleOriginalPrice'] = 0;
    bundlePricing['bundleCurrentPrice'] = 0;
    bundlePricing['bundleDiscountMessage'] = '';
    bundlePricing['totalSavingsFromBundling'] = 0;
    bundlePricing['totalSavingsOverall'] = 0;
    
    // Flatten the selected bundle lines first so the tiered campaign tier can be chosen from the
    // bundle's COMBINED eligible spend (matching the cart / checkout), not each item on its own.
    let lineItems = [];
    if(bundlePricingDataArray.length > 0){
        bundlePricingDataArray.forEach((bundlePricingData, bundlePricingDataIndex) => {
            let selected_variant_array = selectVariantsArray[bundlePricingDataIndex];
            if(selected_variant_array && selected_variant_array.length > 0){
                selected_variant_array.forEach((selected_variant) => {
                    let selected_variant_id = parseInt(selected_variant['variant_id']);
                    let entry = bundlePricingData[`${selected_variant_id}`];
                    if(entry){
                        lineItems.push({
                            handle: entry['handle'],
                            cpx: parseInt(entry['data'][`${selected_variant_id}`].cpx),
                            opx: parseInt(entry['data'][`${selected_variant_id}`].opx)
                        });
                    }
                })
            }
        })
    }

    // Bundle-wide tiered campaign discount, tier chosen from the combined eligible spend.
    let bundleTier = window.Branch.functions.returnBundleTieredDiscount ? window.Branch.functions.returnBundleTieredDiscount(lineItems.map((li) => ({ handle: li.handle, priceCents: li.cpx }))) : null;
    // The bundle's own "save by bundling" stack is 5%, EXCEPT when the active tiered campaign sets
    // bundleDiscountsSwitchedOff (then the tier applies but the +5% bundling is switched off).
    let bundlingPercentage = (bundleTier && bundleTier.bundleDiscountsSwitchedOff) ? 0 : 5;

    // The tiered campaign's message takes precedence over any non-eligible line's (flat/compare-at)
    // message regardless of line order; a non-eligible line's message is only a fallback.
    let tieredDiscountMessage = (bundleTier && bundleTier.percentage > 0) ? (bundleTier.message || '') : '';
    let fallbackDiscountMessage = '';
    lineItems.forEach((lineItem) => {
        let campaignDiscountPercentage = 0;
        let lineOriginalPrice = lineItem.opx;
        let lineDiscountMessage = '';
        let lineIsTiered = false;
        if(bundleTier && bundleTier.eligibleHandles.has(lineItem.handle)){
            // Eligible for the tiered campaign: use the combined-spend tier (not the single-item one).
            campaignDiscountPercentage = bundleTier.percentage;
            lineDiscountMessage = bundleTier.message;
            lineIsTiered = true;
        } else {
            // Not in the tiered campaign — fall back to the normal per-product code discount
            // (flat campaign / compare-at), exactly as before.
            const codeDiscountData = window.Branch.functions.returnDiscountCodeUpdates(lineItem.cpx, lineItem.opx, 0, '', lineItem.handle);
            campaignDiscountPercentage = codeDiscountData.discountAmount;
            lineOriginalPrice = codeDiscountData.originalPrice;
            lineDiscountMessage = codeDiscountData.discountMessage;
        }

        let totalDiscountPercentage = campaignDiscountPercentage + bundlingPercentage;
        bundlePricing['bundleOriginalPrice'] = bundlePricing['bundleOriginalPrice'] + lineOriginalPrice;
        bundlePricing['bundleCurrentPrice'] = bundlePricing['bundleCurrentPrice'] + lineItem.cpx * ((100 - totalDiscountPercentage) / 100);
        bundlePricing['totalSavingsFromBundling'] = bundlePricing['totalSavingsFromBundling'] + (lineOriginalPrice * (bundlingPercentage / 100));
        if(!lineIsTiered && campaignDiscountPercentage > 0 && lineDiscountMessage && lineDiscountMessage.length > 0 && fallbackDiscountMessage === ''){
            fallbackDiscountMessage = lineDiscountMessage;
        }
    })

    bundlePricing['bundleDiscountMessage'] = tieredDiscountMessage || fallbackDiscountMessage;

    // When bundling is switched off but the campaign tier still discounts the bundle, surface the
    // campaign saving in the headline label (otherwise updatePriceElement would show the now-$0
    // "save by bundling" regular label). Fall back to the campaign's headline message.
    if(bundlingPercentage === 0 && bundlePricing['bundleDiscountMessage'] === '' && bundleTier && bundleTier.percentage > 0 && bundleTier.campaignMessage){
        bundlePricing['bundleDiscountMessage'] = bundleTier.campaignMessage;
    }

    // Campaign Sale-swatch override (e.g. "Save up to 18%") when a constituent is in the tiered
    // campaign — shown on the savings label by updatePriceElement.
    bundlePricing['bundleOverrideMessage'] = bundleTier ? (bundleTier.bundleSwatchText || '') : '';
    // A constituent handle covered by the campaign — used to pull the campaign's pre-order swatch
    // tooltip / styling (via returnDiscountCodeUpdates) the same way the PDP does.
    bundlePricing['bundleEligibleHandle'] = bundleTier ? ((lineItems.find((li) => bundleTier.eligibleHandles.has(li.handle)) || {}).handle || '') : '';

    bundlePricing['totalSavingsOverall'] = bundlePricing['bundleOriginalPrice'] - bundlePricing['bundleCurrentPrice'];
    // Stash the resolved tier + bundling % so updateCarouselPricing prices swap options the same
    // way (combined-spend tier, bundling 0 when switched off) and its deltas reconcile with this total.
    bundleBuilderLastTier = bundleTier;
    bundleBuilderLastBundlingPercentage = bundlingPercentage;
    // console.log('bundlePricing', bundlePricing);
    return bundlePricing
}

const updatePriceElement = function(bundlePricing){ 
    let bundleOriginalPrice = bundlePricing['bundleOriginalPrice'];
    let bundleCurrentPrice = bundlePricing['bundleCurrentPrice'];
    let bundleDiscountMessage = bundlePricing['bundleDiscountMessage'];
    let bundleOverrideMessage = bundlePricing['bundleOverrideMessage'] || '';
    let totalSavingsFromBundling = bundlePricing['totalSavingsFromBundling'];
    let totalSavingsOverall = bundlePricing['totalSavingsOverall'];

    let savingsLabelsPrices = document.querySelectorAll('.bundle-builder-price__savings-label .bundle-builder-price__savings-label-inner[data-type="regular"] strong');
    if(savingsLabelsPrices.length === 0) return;
    let priceParents = savingsLabelsPrices[0].closest('.bundle-builder').querySelectorAll('.bundle-builder-price__savings-label-outer-container');


    // console.log('totalSavingsFromBundling', totalSavingsFromBundling)
    savingsLabelsPrices.forEach((savingsLabelsPrice) => {
        savingsLabelsPrice.innerHTML = `<span class="bundle-builder-price__savings-label-inner-message" data-type="mobile">$${Math.floor(parseFloat((totalSavingsFromBundling / 100)), 0)}</span>`;
    });

    // Show the custom label (not the "$X by bundling" regular one) whenever there's a campaign
    // override to display or a discount message.
    priceParents.forEach((priceParent) => {
        if(bundleOverrideMessage != '' || bundleDiscountMessage != ''){
            priceParent.setAttribute('data-display-regular-message', false)
        } else {
            priceParent.setAttribute('data-display-regular-message', true)
        }
    })

    applyBundleBuilderSavingsLabelPromoStyle(priceParents);

    let priceElements = document.querySelectorAll('.bundle-builder .price');
    priceElements.forEach((priceElement) => {
        let currentPriceElement = priceElement.querySelector('.deal span[data-price="deal"]');
        let originalPriceElement = priceElement.querySelector('.retail span[data-price="retail"]');
        let discountCodeElements = priceElement.querySelectorAll('.bundle-builder-price__savings-label .bundle-builder-price__savings-label-inner[data-type="custom"]');
    
        currentPriceElement.innerHTML = `$${window.Branch.functions.numberWithCommas(Math.ceil(parseFloat((bundleCurrentPrice / 100)), 0))}`;
        originalPriceElement.innerHTML = `$${window.Branch.functions.numberWithCommas(Math.ceil(parseFloat((bundleOriginalPrice / 100)), 0))}`;
        
        discountCodeElements.forEach((discountCodeElement) => {
            if(bundleDiscountMessage != ''){
                let bundleDiscountMessageText = `<span class="bundle-builder-price__savings-label-inner-message" data-type="mobile">Save $${Math.floor(parseFloat((totalSavingsOverall / 100)), 0)}</span><span class="bundle-builder-price__savings-label-inner-message" data-type="desktop">Save $${Math.floor(parseFloat((totalSavingsOverall / 100)), 0)} ${bundleDiscountMessage.replaceAll('</p>', '').replaceAll('<p>', '').replace(/with code/gi, 'with')}</span>`
                discountCodeElement.innerHTML = bundleDiscountMessageText;
            } else {
                discountCodeElement.innerHTML = '';
            }
        })

        // Campaign pre-order swatch (label + tooltip): insert as a SIBLING next to the savings-label
        // OUTER container (not inside it), via the shared renderPreOrderSwatch builder. Idempotent —
        // reuses the existing swatch on re-render, removes it when no campaign override applies.
        // Tooltip + styling come from the campaign the same way the PDP does (returnDiscountCodeUpdates).
        let savingsOuter = priceElement.querySelector('.bundle-builder-price__savings-label-outer-container');
        if(savingsOuter){
            let existingSwatch = savingsOuter.parentElement.querySelector(':scope > .pre-order-swatch.bundle-builder-campaign-swatch');
            if(bundleOverrideMessage != '' && window.Branch.functions.renderPreOrderSwatch){
                let swatchEl = existingSwatch;
                if(!swatchEl){
                    swatchEl = document.createElement('div');
                    swatchEl.className = 'pre-order-swatch bundle-builder-campaign-swatch';
                    swatchEl.setAttribute('data-text-transform', 'sentencecase');
                    swatchEl.setAttribute('data-bundle-builder', 'true');
                    savingsOuter.insertAdjacentElement('afterend', swatchEl);
                }
                swatchEl.setAttribute('data-bundle-builder', 'true');
                let eligibleHandle = bundlePricing['bundleEligibleHandle'] || '';
                let swatchData = (eligibleHandle && window.Branch.functions.returnDiscountCodeUpdates) ? window.Branch.functions.returnDiscountCodeUpdates(100, 100, 0, '', eligibleHandle) : {};
                window.Branch.functions.renderPreOrderSwatch(swatchEl, {
                    messageDesktop: bundleOverrideMessage,
                    messageMobile: bundleOverrideMessage,
                    useHtmlTooltip: !!(swatchData.overridePdpTooltip && swatchData.pdpTooltipHtml),
                    tooltipHtml: swatchData.pdpTooltipHtml || '',
                    promoStyling: swatchData.activeCampaignPromoStylingEnabled,
                    swatchColor: swatchData.activeCampaignSwatchColorEnabled,
                    applySentenceCase: true
                });
                // Hide the savings-label message while the swatch is shown, so only the swatch is visible.
                savingsOuter.style.display = 'none';
            } else {
                savingsOuter.style.display = '';
                if(existingSwatch){ existingSwatch.remove(); }
            }
        }
    })
}

/* Updates the +/- pricing in the carousel */

// Resolved tier + bundling % from the last returnBundlePricing run, so the carousel swap-price
// previews use the SAME combined-spend tier and bundling % as the headline bundle total.
let bundleBuilderLastTier = null;
let bundleBuilderLastBundlingPercentage = 5;

const updateCarouselPricing = function(){
    let nonSummaryTabs = document.querySelectorAll('.bundle-builder-form__tabs-container .bundle-builder-form__tab:not(.bundle-builder-form__tab--summary)');
    if(nonSummaryTabs.length > 0){
        // console.log('length', nonSummaryTabs)
        nonSummaryTabs.forEach((tab, tab_index) => {
            let input = tab.querySelector('.bundle-builder-form__selected-product-variants-container input[name="id[]"]');
            if(input){
                let selected_variant_arrays = selectVariantsArray[tab_index]
                let currentTabBundlePricingData = bundlePricingDataArray[tab_index];
                let nonSelectedFormContainers = tab_index < 2 ?  tab.querySelectorAll(`.bundle-builder-form__product-container:not([data-selected="true"]):not([data-product-handle="${selected_variant_arrays[0] ? selected_variant_arrays[0]['product_handle'] : ""}"])`) :  tab.querySelectorAll(`.bundle-builder-form__product-container:not([data-selected="true"])`)
                if(selected_variant_arrays && selected_variant_arrays.length > 0){
                    selected_variant_arrays.forEach((selected_variant) => {
                        let selectedVariantId = selected_variant['variant_id'];
                        let selectedVariantPrice = currentTabBundlePricingData[`${selectedVariantId}`] ? currentTabBundlePricingData[`${selectedVariantId}`]['data'][`${selectedVariantId}`].cpx: 0;
                        let selectedFormContainer = tab.querySelector(`.bundle-builder-form__product-container[data-product-handle="${selected_variant['product_handle']}"]`);

                        if(selectedFormContainer && nonSelectedFormContainers.length > 0){
                            selectedFormContainer.querySelector('.bundle-builder-form__product-price').innerHTML = 'Selected';
                                nonSelectedFormContainers.forEach((nonSelectedFormContainer) => {
                                let nonSelectedSelectedVariantId = tab_index < 2 ? parseInt(nonSelectedFormContainer.querySelector('.bundle-builder-form__product-variants-container input[name="id[]"]').getAttribute('value')) : parseInt(nonSelectedFormContainer.getAttribute('data-first-variant-id'));
                                
                                // console.log('currentTabBundlePricingData!!!', currentTabBundlePricingData)
                                let data = currentTabBundlePricingData[`${nonSelectedSelectedVariantId}`] ? currentTabBundlePricingData[`${nonSelectedSelectedVariantId}`]['data'][`${nonSelectedSelectedVariantId}`] : null;
                                if(data){
                                    let nonSelectedHandle = currentTabBundlePricingData[`${nonSelectedSelectedVariantId}`]['handle'];
                                    const codeDiscountData = window.Branch.functions.returnDiscountCodeUpdates(parseInt(data.cpx), parseInt(data.opx), 0, '', nonSelectedHandle);
                                    // Eligible options take the bundle's combined-spend tier % (so the deltas reconcile with the
                                    // headline total); others keep their single-item code discount. Bundling % is the bundle's (0 when switched off).
                                    let nonSelectedCampaignPct = (bundleBuilderLastTier && bundleBuilderLastTier.eligibleHandles.has(nonSelectedHandle)) ? bundleBuilderLastTier.percentage : ((codeDiscountData.originalPrice - codeDiscountData.currentPrice) / codeDiscountData.originalPrice) * 100;
                                    let codeDiscountAmountPercentage = nonSelectedCampaignPct + bundleBuilderLastBundlingPercentage;
                                    let nonSelectedSelectedVariantOriginalPrice = codeDiscountData.originalPrice;
                                    let nonSelectedSelectedVariantPrice = parseInt(data.cpx) * ((100 - codeDiscountAmountPercentage)/ 100);
                                    let nonSelectPriceElement = nonSelectedFormContainer.querySelector('.bundle-builder-form__product-price');
                                    if(tab_index < 2){
                                        let priceDifference = selectedVariantPrice  - nonSelectedSelectedVariantPrice;
                                        // console.log('priceDifference', priceDifference);
                                        let priceDifferenceString =  `+$0`;
                                        if(priceDifference < 0){
                                            priceDifferenceString = `+$${Math.floor(parseFloat(((0 - priceDifference) / 100)), 0)}`
                                        } else if(priceDifference > 0){
                                            priceDifferenceString = `-$${Math.floor(parseFloat((priceDifference / 100)), 0)}`
                                        }
                                        nonSelectPriceElement.innerHTML = priceDifferenceString;
                                    } else {
                                        if(nonSelectedSelectedVariantOriginalPrice > nonSelectedSelectedVariantPrice){
                                            nonSelectPriceElement.innerHTML = `<span>+$${Math.floor(parseFloat(nonSelectedSelectedVariantOriginalPrice / 100), 0)}</span> +$${Math.floor(parseFloat((nonSelectedSelectedVariantPrice  / 100)), 0)}`;
                                        } else {
                                            nonSelectPriceElement.innerHTML = `+$${Math.floor(parseFloat((nonSelectedSelectedVariantPrice / 100)), 0)}`;
                                        }
                                    }
                                }
                            })
                        } 
                    })
                } else {
                    if(nonSelectedFormContainers.length > 0){
                        nonSelectedFormContainers.forEach((nonSelectedFormContainer) => {
                            let nonSelectedSelectedVariantId = tab_index < 2 ? parseInt(nonSelectedFormContainer.querySelector('.bundle-builder-form__product-variants-container input[name="id[]"]').getAttribute('value')) : parseInt(nonSelectedFormContainer.getAttribute('data-first-variant-id'));
                            
                            let data = currentTabBundlePricingData[`${nonSelectedSelectedVariantId}`]['data'][`${nonSelectedSelectedVariantId}`]
                            let nonSelectedHandle = currentTabBundlePricingData[`${nonSelectedSelectedVariantId}`]['handle'];
                            const codeDiscountData = window.Branch.functions.returnDiscountCodeUpdates(parseInt(data.cpx), parseInt(data.opx), 0, '', nonSelectedHandle);
                            // Eligible options take the bundle's combined-spend tier % (so the deltas reconcile with the
                            // headline total); others keep their single-item code discount. Bundling % is the bundle's (0 when switched off).
                            let nonSelectedCampaignPct = (bundleBuilderLastTier && bundleBuilderLastTier.eligibleHandles.has(nonSelectedHandle)) ? bundleBuilderLastTier.percentage : ((codeDiscountData.originalPrice - codeDiscountData.currentPrice) / codeDiscountData.originalPrice) * 100;
                            let codeDiscountAmountPercentage = nonSelectedCampaignPct + bundleBuilderLastBundlingPercentage;
                            let nonSelectedSelectedVariantOriginalPrice = codeDiscountData.originalPrice;
                            let nonSelectedSelectedVariantPrice = parseInt(data.cpx) * ((100 - codeDiscountAmountPercentage)/ 100);                            
                            let nonSelectPriceElement = nonSelectedFormContainer.querySelector('.bundle-builder-form__product-price');
                            if(nonSelectedSelectedVariantOriginalPrice > nonSelectedSelectedVariantPrice){
                                nonSelectPriceElement.innerHTML = `<span>+$${Math.floor(parseFloat(nonSelectedSelectedVariantOriginalPrice / 100), 0)}</span> +$${Math.floor(parseFloat((nonSelectedSelectedVariantPrice / 100)), 0)}`;
                            } else {
                                nonSelectPriceElement.innerHTML = `+$${Math.floor(parseFloat((nonSelectedSelectedVariantPrice / 100)), 0)}`;
                            }
                        })
                    }
                }
            }
        })
    }
}

const handleForwardBackButtonClick = function(type){
    backForwardButtonsContainer.setAttribute('data-disabled', true);
    if(type == 'forward'){
        if(step  < total_steps){
            step = step + 1
            formContainer.setAttribute('data-step', step);
            bundleBuilderContainer.setAttribute('data-step', step);

            if(step == total_steps){
                showCollection(order_string_array[step - 1], true, 'click');    
            }
            else if(step != total_steps){
                showCollection(order_string_array[step - 1], false, 'click');
            }
            checkAndScroll();
            adjustStickyTop();
        }
    } else {
        if(step != 1){
            step = step - 1
            formContainer.setAttribute('data-step', step);
            bundleBuilderContainer.setAttribute('data-step', step);
            showCollection(order_string_array[step - 1], false, 'click');

            checkAndScroll();
            adjustStickyTop();
        } else {
            if(backForwardButtonsContainer.getAttribute('data-back-button-hidden') == 'false') {
                history.back()
            }
        }
    }
}

const calculateFirstStepBackButton = function(backForwardButtonsData){
       
        let product_url = urlArray.find(url => url.includes('/products/')) || false;
        if(product_url){
            // AS - back button shows up when coming from the PDP
            backForwardButtonsContainer.setAttribute('data-back-button-hidden', false);
            backForwardButtonsContainer.setAttribute('data-back-product-url', product_url);
        } else {
            backForwardButtonsContainer.setAttribute('data-back-button-hidden', true);
            backForwardButtonsContainer.setAttribute('data-back-product-url', "");
        }

}

const updateBackForwardButtons = function(){
    let back_button = backForwardButtonsContainer.querySelectorAll('.bundle-builder__back-forward-button')[0]
    let forward_button = backForwardButtonsContainer.querySelectorAll('.bundle-builder__back-forward-button')[1]
    
    if(step >= total_steps){
        forward_button.innerHTML = "ADD TO CART";
        forward_button.addEventListener('click', addItemstoCart)
    } else {
        forward_button.removeEventListener('click', addItemstoCart)
        if(step < 3){
            forward_button.innerHTML = "CONTINUE"
        } else {
            let input = document.querySelector(`.bundle-builder-form__tab[data-index="${step - 1}"]`).querySelector('input.bundle-builder-form__addons-input');
            let addonsData = input && input.getAttribute('value') ? JSON.parse(`${input.getAttribute('value')}`) : [];
            
            if(addonsData.length > 0){
                forward_button.innerHTML = "CONTINUE"
            } else {
                let collection_title = collection_titles[step - 1]
                if(collection_title != 'accessories'){
                    collection_title = `${collection_title}s`
                }
                forward_button.innerHTML = `SKIP`
            }
        }
    }
}

/* Updates sessionStorage to includes currently selected variants */
const saveSelectedVariantsToLocalStorage = function(){
    sessionStorage.setItem('selectedBundleVariants', JSON.stringify(selectVariantsArray));
}

const initBackFowardButtonClickListeners = function(backForwardButtonsData){
   
    let forward_button = backForwardButtonsContainer.querySelector('.bundle-builder__back-forward-button[data-direction="forward"]');
    let back_button = backForwardButtonsContainer.querySelector('.bundle-builder__back-forward-button[data-direction="back"]');
    
    forward_button.addEventListener('click', function(){
        if ($(forward_button).attr('data-direction') == "checkout"){
            forward_button.removeEventListener('click', addItemstoCart)
            window.location.href = '/checkout'
        }else {
            handleForwardBackButtonClick('forward', total_steps)
        }
    })

    back_button.addEventListener('click', function(){
        if ($(back_button).attr('data-direction') == "view_cart"){
            animate = true;
            showSideCart(animate)
        }
        else {
            handleForwardBackButtonClick('back', total_steps)
        }
    })
}

const initBackForwardButtons = function(){
    let backForwardButtonsData = {};

    updateBackForwardButtons(backForwardButtonsData);
    calculateFirstStepBackButton(backForwardButtonsData);
    initBackFowardButtonClickListeners(backForwardButtonsData);
}

const updateProductOneLineDescription = function(tab_index, product_id){
    let oneLineDescriptionElement = document.querySelector(`.bundle-builder-form__tab[data-index="${tab_index}"] .bundle-builder-form__product-one-line-description`);
    let html = unescapeHtml(product_data[`${product_id}`]['description']);
    oneLineDescriptionElement.innerHTML = html;    
}

window.Branch.bundle.updatePricing = function(fromLoad){
    if(fromLoad == true){
        if(selectVariantsArray.length == 0){
            selectVariantsArray = returnSelectVariantsArray();
        }
    } else {
        selectVariantsArray = returnSelectVariantsArray();
    }

    saveSelectedVariantsToLocalStorage();
    let bundlePricing = returnBundlePricing();
    // console.log('bundlePricing', bundlePricing)
    updatePriceElement(bundlePricing);
    let bundleCurrentPrice = bundlePricing['bundleCurrentPrice'];
    if(window.Branch && window.Branch.installmentsBanner && window.Branch.installmentsBanner.initInstallmentsBanner) {
        window.Branch.installmentsBanner.initInstallmentsBanner('pdp', bundleCurrentPrice);
    }
    updateCarouselPricing();
    window.Branch.functions.saleTagUpdate(null, null, bundlePricing['bundleOriginalPrice'], bundleCurrentPrice, null, 'bundle');
}

window.Branch.bundle.secondaryGalleryImages = function(){
    let first_collection_variant_id = parseInt(document.querySelector('.bundle-builder-form__tab[data-index="0"] .bundle-builder-form__selected-product-variants-container input[name="id[]"]').value)
    let second_collection_variant_id = parseInt(document.querySelector('.bundle-builder-form__tab[data-index="1"] .bundle-builder-form__selected-product-variants-container input[name="id[]"]').value)
    let first_collection_data = variant_data[`${first_collection_variant_id}`];
    let second_collection_data = variant_data[`${second_collection_variant_id}`]
    let first_collection_variant_img_url_srcset = window.Branch.functions.returnSrcSet(first_collection_data['image_url']);
    let second_collection_variant_img_url_srcset = window.Branch.functions.returnSrcSet(second_collection_data['image_url']);
    let first_collection_variant_title = first_collection_data['variant_title'];
    let second_collection_variant_title = second_collection_data['variant_title'];
    let first_image = document.querySelector('.bundle-builder-gallery__image.second_img_chair')
    let second_image = document.querySelector('.bundle-builder-gallery__image.third_img_desk')
    
    first_image.setAttribute('srcset', first_collection_variant_img_url_srcset)
    first_image.setAttribute('alt', first_collection_variant_title);
    second_image.setAttribute('srcset', second_collection_variant_img_url_srcset)
    second_image.setAttribute('alt', second_collection_variant_title);
}

const findProductTab = function(productId) {
    for (let tab of tabs) {
        const productContainers = tab.querySelectorAll('.bundle-builder-form__product-container');
        for (let container of productContainers) {
            if (parseInt(container.getAttribute('data-product-id')) == productId) {
                return tab;
            }
        }
    }
    return null; // Return null if no matching element is found
}

const handleCheckedCoverClick = function(e){
    e.target.style.pointerEvents = "none";
    let targetElement = e.target.closest('.bundle-builder-form__product-container')
    let targetElementHandle = targetElement.getAttribute('data-product-handle');
    let input = targetElement.closest('.bundle-builder-form__tab ').querySelector('input.bundle-builder-form__addons-input');
    let addonsData = input.getAttribute('value') ? JSON.parse(`${input.getAttribute('value')}`) : [];
    let tab_index = parseInt(targetElement.closest('.bundle-builder-form__tab').getAttribute('data-index'))
    if(addonsData.length > 0){
        let newData = [];
        addonsData.forEach((dataLine) => {
            if(dataLine[`productHandle`] != targetElementHandle){
                newData.push(dataLine);
            }
        })
        input.value = JSON.stringify(newData);
        input.setAttribute('value', JSON.stringify(newData));
        selectVariantsArray[tab_index] = newData;
        saveSelectedVariantsToLocalStorage();
    }
    addonsCheck();
    window.Branch.bundle.updatePricing();
    window.Branch.bundle.updateGalleryImage();
    window.Branch.bundle.updateCTAURLParams();
    window.Branch.bundle.updateSummaryTab();
}

const findElementByProductHandle = (elements, handle) => [...elements].find(el => el.getAttribute('data-product-handle') === handle);
const findProductByHandle = (products, product_handle) => products.find(product => product.handle === product_handle);
const findProductById = (products, product_id) => products.find(product => product.id === product_id);

const addonsCheck = function(){
    let addonsTabs = document.querySelectorAll('.bundle-builder-form__tab:not([data-index="0"]):not([data-index="1"]):not(.bundle-builder-form__tab--summary)');
    if(addonsTabs.length > 0){
        addonsTabs.forEach((addonsTab) => {
            let addonsInTab = addonsTab.querySelectorAll('.bundle-builder-form__product-container');
            let input = addonsTab.querySelector('input.bundle-builder-form__addons-input');
            let addonsData = input.getAttribute('value') ? JSON.parse(`${input.getAttribute('value')}`) : [];
            addonsInTab.forEach((addon) => {
                addon.setAttribute('data-selected', false);
                let selectedCover =  addon.querySelector('.bundle-builder-form__addon-selected-cover');
                if(selectedCover){
                    selectedCover.remove();
                }
            });
            if(addonsData.length > 0){
                addonsData.forEach((dataLine) => {
                    let matchingElement = findElementByProductHandle(addonsInTab, dataLine['productHandle']);
                    if(matchingElement){
                        matchingElement.setAttribute('data-selected', true);
                        let addonCheckedCover = document.createElement("div"); 
                        addonCheckedCover.classList.add('bundle-builder-form__addon-selected-cover');
                        matchingElement.appendChild(addonCheckedCover);
                        addonCheckedCover.addEventListener('click', handleCheckedCoverClick);
                    }    
                })
            }
        })
    }
    updateBackForwardButtons();
}

window.Branch.bundle.handleAddOnClick = function(variant_id, product_id, product_handle) {
    let relevant_tab = findProductTab(product_id);
    let tab_index = parseInt(relevant_tab.getAttribute('data-index'));
    let input = relevant_tab.querySelector('input.bundle-builder-form__addons-input');
    let current_value = input.getAttribute('value') ? JSON.parse(`${input.getAttribute('value')}`) : [];
    let new_object = {"productHandle": `${product_handle}`, "variantId": `${variant_id}`, 'quantity': 1};
    let new_value = current_value;
    new_value.push(new_object);
    input.value = JSON.stringify(new_value);
    input.setAttribute('value', JSON.stringify(new_value));
    selectVariantsArray[tab_index] = new_value;
    saveSelectedVariantsToLocalStorage();
    addonsCheck();
    window.Branch.bundle.updatePricing();
    window.Branch.bundle.updateGalleryImage();
    window.Branch.bundle.updateCTAURLParams();
    window.Branch.bundle.updateSummaryTab();
}

window.Branch.bundle.bundleBuilderPreloadImages = function(type){
    if(type == "init"){
        let initialProducts = [];
        let first_handle = document.querySelector('.bundle-builder-form__tab[data-index="0"]  .bundle-builder-form__selected-product-variants-container .select-variant').getAttribute('data-handle');
        let second_handle = document.querySelector('.bundle-builder-form__tab[data-index="1"]  .bundle-builder-form__selected-product-variants-container .select-variant').getAttribute('data-handle')
        let third_handle = document.querySelectorAll(`.bundle-builder-form__tab[data-index="0"] .bundle-builder-form__product-container`)[1] ? document.querySelectorAll(`.bundle-builder-form__tab[data-index="0"] .bundle-builder-form__product-container`)[1].getAttribute('data-product-handle') : undefined;
        let initialProductsIndices = [0, 1, 0]

        initialProducts.push(findProductByHandle(products, first_handle));
        initialProducts.push(findProductByHandle(products, second_handle));
        if(third_handle){initialProducts.push(findProductByHandle(products, third_handle));}

        initialProducts.forEach((initialProduct, index) => {
            window.Branch.product.preloadImages(initialProduct, 'init', 'bundle-builder-sub-images', `.bundle-builder-form__tab[data-index="${initialProductsIndices[index]}"] .bundle-builder-form__selected-product-variants-container`);
            window.Branch.product.preloadImages(initialProduct, 'init', 'bundle-builder-overlay-images', `.bundle-builder-form__tab[data-index="${initialProductsIndices[index]}"] .bundle-builder-form__selected-product-variants-container`);
        });
        init_images_preloaded = true;
        setTimeout(() => {
            document.querySelectorAll('.bundle-builder-gallery__preset-loading-image').forEach((loadingImage) => {loadingImage.setAttribute('data-visible', false)});
            document.querySelectorAll('.bundle-builder-gallery__main-image-container').forEach((mainImage) => {mainImage.style.removeProperty('opacity')});
        }, 250)
    } else if(type == "click"){
        let allProducts = [];
        let allProductsContainers = document.querySelectorAll('.bundle-builder-form__tab[data-index="0"] .bundle-builder-form__product-container, .bundle-builder-form__tab[data-index="1"] .bundle-builder-form__product-container');
        allProductsContainers.forEach((allProductsContainer) => {
            allProducts.push(findProductByHandle(products, allProductsContainer.getAttribute('data-product-handle')));
        })
        allProducts.forEach((product) => {
            window.Branch.product.preloadImages(product, 'click', 'bundle-builder-sub-images', `.bundle-builder-form__tab`);
        })
        if(!window.Branch.bundle._overlayImagesPreloaded){
            window.Branch.bundle._overlayImagesPreloaded = true;
            window.Branch.product.preloadImages(undefined, 'click', 'bundle-builder-overlay-images', `.bundle-builder-form__tab`);
        }
    }
}

const removeInvalidSummaryItems = function(elements, variantsArrayForSummary) {
    let validVariantIds = variantsArrayForSummary.flat().map(variant => variant.variant_id);
    const matchedVariantIds = new Set();
     
     elements.forEach(element => {
         const variantId = element.getAttribute('data-variant-id');
         
         if (validVariantIds.includes(variantId)) {
             matchedVariantIds.add(variantId);
         } else {
             element.remove();
         }
     });
     
     variantsArrayForSummary.forEach(subArray => {
         for (let i = subArray.length - 1; i >= 0; i--) {
             if (matchedVariantIds.has(subArray[i].variant_id)) {
                 subArray.splice(i, 1);
             }
         }
     });
}

const returnSummaryItem = function(selectedVariant){
    let summaryItem = document.createElement('div');
    summaryItem.classList.add('bundle-builder__summary-item');
    summaryItem.setAttribute('data-variant-id', selectedVariant['variant_id']);
    let summaryItemHtml = `
    <div class="bundle-builder__summary-item-inner-container">
        <div class="bundle-builder__summary-item-image-container">
            <img
                class="bundle-builder__summary-item-image"
                srcset="${selectedVariant['iur']}&width=180 180w, ${selectedVariant['iur']}&width=360 360w, ${selectedVariant['iur']}&width=540 540w"
                width="200"
                height="200"
                sizes="(max-width: 600px) 30vw, calc(45vw * 0.33)"
            >
        </div>
        <div class="bundle-builder__summary-item-text-container">
            <h4 class="bundle-builder__summary-item-title">${selectedVariant['variant_title'].split(" -")[0]}</h4>
            <p class="bundle-builder__summary-item-msbd">${selectedVariant['variant_msbd_string'].replace('Ships in', 'Ships for free in')}</p>
        </div>
    </div>`
    summaryItem.innerHTML = summaryItemHtml;
    return summaryItem
}

const hideShowAddons = function(){
    if(total_steps > 3){
        // Swiper lazy-load guard — matches `initProductsSlider`.
        if (typeof window.Swiper === 'undefined') {
            if (typeof window.whenSwiperReady === 'function') {
                window.whenSwiperReady(function(){ hideShowAddons(); });
            }
            return;
        }
        let addonsTab = tabs[2];

        addonsTab.querySelectorAll('.bundle-builder-form__product-container').forEach(el => el.setAttribute('data-hidden', current_compatible_addons.includes(el.getAttribute('data-product-handle')) ? 'false' : 'true'));
        let addonSwiper = bundle_builder_swipers[2];

        addonSwiper.destroy(true, true);

        let swiper_options = returnSwiperOptions(2);
        var bundleBuilderProductSwiper = new Swiper(`.bundle-builder-form__tab[data-index="2"] .bundle-builder-form__products-list-container`, swiper_options);
        
        // if(selectVariantsArray[2] && selectVariantsArray[2][0]){
        //     let indexToSwipeTo = [...addonsTab.querySelectorAll('.bundle-builder-form__product-container')].findIndex(el => el.dataset.productHandle === selectVariantsArray[2][0]['product_handle']);
        //     let visibleIndexToSwipeTo = [...addonsTab.querySelectorAll('.bundle-builder-form__product-container:not([data-hidden="true"])')].findIndex(el => el.dataset.productHandle === selectVariantsArray[2][0]['product_handle']);

        //     if(visibleIndexToSwipeTo > 3){
        //         setTimeout(() => {
        //             bundleBuilderProductSwiper.update();
        //             bundleBuilderProductSwiper.slideToLoop(indexToSwipeTo - 2, 250);
        //           }, 500);
        //     };
        // }

        bundle_builder_swipers[2] = bundleBuilderProductSwiper;
    }
}

window.Branch.bundle.updateSummaryTab = function(){
    let summaryContainer = document.querySelector('.bundle-builder__summary-inner-container');
    let summaryItems = summaryContainer.querySelectorAll('.bundle-builder__summary-item');
    let variantsArrayForSummary = JSON.parse(JSON.stringify(selectVariantsArray));
    if(summaryItems.length > 0){
        removeInvalidSummaryItems(summaryItems, variantsArrayForSummary);
    }

    variantsArrayForSummary.forEach((selectVariantsSubArray) => {
        if(selectVariantsSubArray.length > 0){
            selectVariantsSubArray.forEach((selectedVariant) => {
                let summaryItem = returnSummaryItem(selectedVariant);
                summaryContainer.appendChild(summaryItem);

                // For composite products (e.g. the Tria Standing Desk) the per-variant image (`iur`)
                // is unreliable — composites are rendered from layered images, not a single variant
                // image — so render the composite into the summary thumbnail, matching the carousel and
                // gallery. Falls back to the `iur` <img> already in the container when no composite exists.
                let imageContainer = summaryItem.querySelector('.bundle-builder__summary-item-image-container');
                if(imageContainer){
                    try {
                        window.Branch.compositeRenderImage.initRenderImagesForBundleBuilder(selectedVariant, imageContainer, false);
                    } catch (error) {
                        console.error('Error rendering composite image for summary item:', error);
                    }
                }
            })
        }
    })
}

const updateCarouselImages = function(){
   let productCarouselItems = document.querySelectorAll('.bundle-builder-form__product-container');
   productCarouselItems.forEach((productCarouselItem) => {
    productCarouselItem.setAttribute('data-thumbnnail-updated', false)
   });

   selectVariantsArray.forEach((selectVariantsTab) => {
    selectVariantsTab.forEach((selectedVariant) => {
        // console.log('productCarouselItems', productCarouselItems)
        let selectedCarouselItem = Array.from(productCarouselItems).find(item => item.getAttribute('data-product-handle') == selectedVariant['product_handle']);
        let selectedImage = selectedCarouselItem.querySelector('.bundle-builder-form__product-image-container img');

        // console.log('selectedImage', selectedImage)

        // Get the image container
        let imageContainer = selectedCarouselItem.querySelector('.bundle-builder-form__product-image-container');

        // Call composite image function for regular layers (not bundle builder layers)
        let compositeImageReplacementFound = false;
        try {
            // Empty the container first
            imageContainer.innerHTML = '';

            compositeImageReplacementFound = window.Branch.compositeRenderImage.initRenderImagesForBundleBuilder(selectedVariant, imageContainer, false);
            console.log('Composite image function returned:', compositeImageReplacementFound, 'for carousel variant:', selectedVariant.variant_id);
        } catch (error) {
            console.error('Error in composite image function for carousel:', error);
            compositeImageReplacementFound = false;
        }

        // Only create regular image if composite wasn't created
        if(compositeImageReplacementFound !== true){
            // Create a new image element
            let newImage = document.createElement('img');
            newImage.setAttribute('alt', `${selectedVariant['variant_title']}`);
            newImage.setAttribute('srcset', `${selectedVariant['iur']}&width=180 180w, ${selectedVariant['iur']}&width=360 360w`);
            newImage.setAttribute('src', `${selectedVariant['iur']}&width=180`);
            newImage.setAttribute('loading', 'lazy');
            newImage.setAttribute('width', '180');
            newImage.setAttribute('height', '180');
            newImage.classList.add('bundle-builder-form__product-image');

            // Add the new image to the container
            imageContainer.appendChild(newImage);
        }
    })
   });

   document.querySelectorAll('.bundle-builder-form__tab[data-index="0"] .bundle-builder-form__product-container[data-render-composite-thumbnail="true"], .bundle-builder-form__tab[data-index="1"] .bundle-builder-form__product-container[data-render-composite-thumbnail="true"]').forEach((tile) => {
       let imageContainer = tile.querySelector('.bundle-builder-form__product-image-container');
       if(!imageContainer || imageContainer.querySelector('.bundle-builder-composite-wrapper')) return; // already composited
       let product = (typeof products !== 'undefined') ? findProductById(products, parseInt(tile.getAttribute('data-product-id'))) : null;
       let firstVariant = product && product.variants ? product.variants[0] : null;
       if(!firstVariant) return;
       // Build the options string in the "{ 'Name': 'Value', … }" shape initRenderImagesForBundleBuilder parses.
       let optionsObj = {};
       (product.options || []).forEach((optionName, i) => { optionsObj[optionName] = (firstVariant.options || [])[i]; });
       let optionsString = '{ ' + Object.keys(optionsObj).map((k) => `'${k}': '${optionsObj[k]}'`).join(', ') + ' }';
       let variantObj = { product_id: firstVariant.product_id || product.id, options: optionsString, variant_title: firstVariant.name || firstVariant.title || product.title };
       try {
           window.Branch.compositeRenderImage.initRenderImagesForBundleBuilder(variantObj, imageContainer, false);
       } catch (error) { /* leave the server fallback image in place */ }
   });

   /* Update all addon thumbnails to match selected chair/desk variants */

   let addOnProductCarouselItems = tabs[2].querySelectorAll('.bundle-builder-form__product-container[data-hidden="false"]:not([data-thumbnail-updated="true"]):not([data-selected="true"])');
   
   if(addOnProductCarouselItems.length > 0){
    let selectedChairDeskProducts = [selectVariantsArray[0][0], selectVariantsArray[1][0]];
    addOnProductCarouselItems.forEach((addOnProductCarouselItem) => {
        let addOnId = parseInt(addOnProductCarouselItem.getAttribute('data-product-id'));
        let addOnHandle = addOnProductCarouselItem.getAttribute('data-product-handle');
        let addOnProduct = findProductById(products, addOnId);
   
        let selectedProduct;
        selectedChairDeskProducts.forEach((selectedChairDeskProduct) => {
            let selectedChairDeskProductAddons = product_data[`${selectedChairDeskProduct['product_id']}`]['addon_handles'].replace(/\s/g, '').split(',');

            if(selectedChairDeskProductAddons.includes(addOnHandle)){
                selectedProduct = selectedChairDeskProduct;
            }
        })
        let newProductAddOn = window.Branch.product.returnMatchingVariantAddOn(selectedProduct, addOnHandle, addOnProduct);
        let selectedImage = addOnProductCarouselItem.querySelector('.bundle-builder-form__product-image-container img');

        selectedImage.setAttribute('alt', `${variant_data[`${newProductAddOn.id}`]['variant_title']}`);
        selectedImage.setAttribute('srcset', `${variant_data[`${newProductAddOn.id}`]['iur']}&width=180 180w, ${variant_data[`${newProductAddOn.id}`]['iur']}&width=360 360w`);
    })
   }

   /* Update all accessory thumbnails to match selected chair/desk variants */

   if(tabs[3]){
       // Note: Removed [data-hidden="false"] filter because accessories don't have data-hidden attribute set
       let accessoryProductCarouselItems = tabs[3].querySelectorAll('.bundle-builder-form__product-container:not([data-thumbnail-updated="true"]):not([data-selected="true"])');

       if(accessoryProductCarouselItems.length > 0){
           let selectedChairDeskProducts = [selectVariantsArray[0][0], selectVariantsArray[1][0]];

           accessoryProductCarouselItems.forEach((accessoryProductCarouselItem) => {
               let accessoryId = parseInt(accessoryProductCarouselItem.getAttribute('data-product-id'));
               let accessoryHandle = accessoryProductCarouselItem.getAttribute('data-product-handle');
               let accessoryProduct = findProductById(products, accessoryId);

               let selectedProduct;
               selectedChairDeskProducts.forEach((selectedChairDeskProduct) => {
                   let selectedChairDeskProductAddons = product_data[`${selectedChairDeskProduct['product_id']}`]['addon_handles'].replace(/\s/g, '').split(',');

                   if(selectedChairDeskProductAddons.includes(accessoryHandle)){
                       selectedProduct = selectedChairDeskProduct;
                   }
               })

               // Only update thumbnail if this accessory is compatible with the selected chair/desk
               if(selectedProduct){
                   let newProductAccessory = window.Branch.product.returnMatchingVariantAddOn(selectedProduct, accessoryHandle, accessoryProduct);
                   let selectedImage = accessoryProductCarouselItem.querySelector('.bundle-builder-form__product-image-container img');

                   selectedImage.setAttribute('alt', `${variant_data[`${newProductAccessory.id}`]['variant_title']}`);
                   selectedImage.setAttribute('srcset', `${variant_data[`${newProductAccessory.id}`]['iur']}&width=180 180w, ${variant_data[`${newProductAccessory.id}`]['iur']}&width=360 360w`);
               }
           })
       }
   }
}

const addonsHideMatchingSwatches = function(variantMatchData, productId){
    variantMatchData.forEach((variantMatchDataLine) => {
        let nameOfSwatchToHide = variantMatchDataLine['add-on-option-name'].toLowerCase().replace(/[^a-z0-9\s]/g, '').trim().replace(/\s+/g, '-');
        let matchNotRequired = variantMatchDataLine?.['match-not-required-if-other-options-match'] === true;
        if(matchNotRequired == false){
            let swatchToHide = document.querySelector(`#main-product-item-${productId} .swatch[data-option-name="${nameOfSwatchToHide}"]`);
            if(swatchToHide){
                swatchToHide.style.display = 'none'
            }
        }
    });
}



/* update already-selected addons when chair/desk variant is updated */

window.Branch.bundle.updateSelectedAddons = function (){
    let addonsArray = selectVariantsArray[2];
    let updatesMade = false;
    if(addonsArray && addonsArray.length > 0){
        addonsArray.forEach((addon) => {
            let matchFound = false;
            let selectedChairDeskProducts = [selectVariantsArray[0][0], selectVariantsArray[1][0]];
            selectedChairDeskProducts.forEach((selectedProduct) => {
                if(matchFound == false){
                    let selectedProductAddons = product_data[`${selectedProduct[`product_id`]}`]['addon_handles'].split(',');
                    if (selectedProductAddons.some(e => e.trim() == addon['product_handle'])) {
                        matchFound = true;
                        let addOnProduct = products.find(product => product.id ===  addon['product_id']);
                        let newProductAddOn = window.Branch.product.returnMatchingVariantAddOn(selectedProduct, addon['product_handle'], addOnProduct);
                        let newAddOnObject = {}
                        newAddOnObject['productHandle'] = addon['product_handle'];
                        newAddOnObject['quantity'] = 1
                        newAddOnObject['variantId'] = newProductAddOn['id'];
                        updateAddons('replace', newAddOnObject, 2, newProductAddOn['id']);
                        if(parseInt(newProductAddOn['id']) != parseInt(addon['variant_id'])){
                            updatesMade = true;
                        }
                      }
                }
            })
        })
    }
    if(updatesMade == true){
        addonsCheck();
        window.Branch.bundle.updatePricing();
        window.Branch.bundle.updateGalleryImage();
        window.Branch.bundle.updateCTAURLParams();
        window.Branch.bundle.updateSummaryTab();
    }
}

/* update already-selected accessories when chair/desk variant is updated */

window.Branch.bundle.updateSelectedAccessories = function (){
    let accessoriesArray = selectVariantsArray[3];
    let updatesMade = false;
    if(accessoriesArray && accessoriesArray.length > 0){
        accessoriesArray.forEach((accessory) => {
            let matchFound = false;
            let selectedChairDeskProducts = [selectVariantsArray[0][0], selectVariantsArray[1][0]];
            selectedChairDeskProducts.forEach((selectedProduct) => {
                if(matchFound == false){
                    let selectedProductAddons = product_data[`${selectedProduct[`product_id`]}`]['addon_handles'].split(',');
                    if (selectedProductAddons.some(e => e.trim() == accessory['product_handle'])) {
                        matchFound = true;
                        let accessoryProduct = products.find(product => product.id ===  accessory['product_id']);
                        let newProductAccessory = window.Branch.product.returnMatchingVariantAddOn(selectedProduct, accessory['product_handle'], accessoryProduct);
                        let newAccessoryObject = {}
                        newAccessoryObject['productHandle'] = accessory['product_handle'];
                        newAccessoryObject['quantity'] = 1
                        newAccessoryObject['variantId'] = newProductAccessory['id'];
                        updateAddons('replace', newAccessoryObject, 3, newProductAccessory['id']);
                        if(parseInt(newProductAccessory['id']) != parseInt(accessory['variant_id'])){
                            updatesMade = true;
                        }
                      }
                }
            })
        })
    }
    if(updatesMade == true){
        addonsCheck();
        window.Branch.bundle.updatePricing();
        window.Branch.bundle.updateGalleryImage();
        window.Branch.bundle.updateCTAURLParams();
        window.Branch.bundle.updateSummaryTab();
    }
}

const linkOptionSelectorsInit = function(product){
        let item = document.querySelector(`.bundle-builder-form__product-variants-inner-container[data-product-handle="${product.handle}"]`)
        if(product.options.length > 1) {
            if(product.variants.length > 1) {
                window.Branch.product.linkOptionSelectors(product, item);
            }
        }
}


/* Update the selected chair/desk product from comparison-chart click */
const updateSelectedChairDeskFromComparisonChart = function(productId, type, comparisonChart){

    /* Click on carousel item */
    let item = document.querySelector(`.bundle-builder__item .bundle-builder-form__tab[data-type="${type}"] .bundle-builder-form__product-container[data-product-id="${productId}"]`);
    let index = parseInt(document.querySelector(`.bundle-builder__item .bundle-builder-form__tab[data-type="${type}"] `).getAttribute('data-index'));
    if(item){
        item.click();
        let currentSwiper = bundle_builder_swipers[index];
        let indexOfItem = Array.prototype.indexOf.call(item.parentNode.children, item);
        currentSwiper.slideTo(indexOfItem);
    }

    /* Close modal */
    comparisonChart.closest('.tingle-modal-box').querySelector('.tingle-modal__close').click();
}

/* Update the comparison chart on-init to add event listners and remove anchor tags */
window.Branch.bundle.updateComparisonChart = function (comparisonChart){
    let titles = comparisonChart.querySelectorAll('._product_title');
    if(titles.length > 0){
        let images = comparisonChart.querySelectorAll('._product_image');
        comparisonChart.setAttribute('data-add-button-inserted', true)

        titles.forEach((title, index) => {
            let titleAddButtonHtml = `<h4>${title.querySelector('a').innerHTML}</h4><div class="_product_title-add-button"><svg aria-hidden="true" tabindex="-1" role="presentation" class=" icon icon-addon-plus" viewBox="0 0 32 32"><circle e="" cx="16" cy="16" r="15.5" fill="transparent" stroke="#314438"></circle><path d="M15.7768 22.1031H17.373V16.9878H22.4883V15.401H17.373V10.2857H15.7768V15.401H10.6616V16.9878H15.7768V22.1031Z" fill="#314438"></path></svg></div>`;
            let imageHTML = `<div class="_product_image-container">${images[index].querySelector('a').innerHTML}</div>`;
            images[index].innerHTML = imageHTML;
            
            let productId = title.closest('ul').getAttribute('data-product-id');
            let type = comparisonChart.querySelector('#section-outer').getAttribute('data-type');
            
            title.innerHTML = titleAddButtonHtml;
            title.addEventListener('click', () => updateSelectedChairDeskFromComparisonChart(productId, type, comparisonChart))
            images[index].addEventListener('click', () => updateSelectedChairDeskFromComparisonChart(productId, type, comparisonChart))
        })
    }
}

const swapAdjacentElements = function(element1, element2, element1Attributes, element2Attributes) {
    if (element1.nextElementSibling !== element2) {
        // console.error('Elements are not adjacent.');
        return;
    }

    element1Attributes.forEach((attribute) => {
        element1.setAttribute(`${Object.keys(attribute)}`, `${Object.values(attribute)}`)
    });

    element2Attributes.forEach((attribute) => {
        element2.setAttribute(`${Object.keys(attribute)}`, `${Object.values(attribute)}`)
    });

    const parent = element1.parentNode;
    parent.insertBefore(element2, element1);
}

/* Checks if any non-desk/non-chair/non-add-on products were previously added and saved in SessionStorage, and re-adds them if so */
const updatePreSelectedNonDeskChairAddonProducts = function(){
    const otherTabs = [...tabs].filter((_, index, arr) => ![0, 1, 2, arr.length - 1].includes(index));
    if(otherTabs.length > 0){
        otherTabs.forEach((otherTab) => {
            if(selectedVariantsFromSessionStorage.length > 0){
            let tabDataIndex = parseInt(otherTab.getAttribute('data-index'));
            let prevSelectedItemsInCategory = selectedVariantsFromSessionStorage[tabDataIndex] ? JSON.parse(JSON.stringify(selectedVariantsFromSessionStorage[tabDataIndex])) : [];
                if(prevSelectedItemsInCategory.length > 0){
                    let input = otherTab.querySelector('.bundle-builder-form__selected-product-variants-container input.bundle-builder-form__addons-input ')
                    let inputValue = [];
                    prevSelectedItemsInCategory.forEach((prevSelectedItem) => {
                        let prevOSelectedObject = {"productHandle": prevSelectedItem['product_handle'], "variantId": `${parseInt(prevSelectedItem['variant_id'])}`, quantity: 1 }
                        inputValue.push(prevOSelectedObject);
                    });
                    input.value = JSON.stringify(inputValue);
                    input.setAttribute('value', JSON.stringify(inputValue));
                    addonsCheck()
                }
            }
        })
    }
}

window.Branch.bundle.shiftSlideDownContent = function(type){
    if(!slideDownPrice){slideDownPrice = document.querySelector('.bundle-builder__slide-down-pricing');}
    if(!priceInstallmentsWrapper){priceInstallmentsWrapper = document.querySelector('.price-installments-wrapper.price-installments-wrapper__bundles');}
    if(slideDownPrice  && priceInstallmentsWrapper){
        let slideDownPriceInner = slideDownPrice.querySelector('.bundle-builder__slide-down-pricing-inner');
        let price = type == 'open' ? priceInstallmentsWrapper.querySelector('.price') : slideDownPrice.querySelector('.price');
        let shopifyInstallments = type == 'open' ? priceInstallmentsWrapper.querySelector('.shopify-installments') : slideDownPrice.querySelector('.shopify-installments');
        let fsaHsa = type == 'open' ? priceInstallmentsWrapper.querySelector('.fsa-hsa') : slideDownPrice.querySelector('.fsa-hsa');
        if(type == 'open'){
            if(slideDownPrice.getAttribute('data-has-contents') == 'false'){
                let prevHeight = 0;
                if(price){prevHeight = prevHeight + 30;}
                if(shopifyInstallments){prevHeight = prevHeight + 23.797 + 8;}
                if(fsaHsa){prevHeight = prevHeight + 20.406 + 8;}

                slideDownPrice.setAttribute('data-has-contents', 'true');
                priceInstallmentsWrapper.style.height = `${prevHeight}px`;

                /* The bundle title is static, so the bar takes a clone rather than the live
                   node the price/installments/FSA use — moving it would leave a gap in the
                   page and need its own stand-in + height compensation. Marked aria-hidden
                   because the real heading is still in the document, just scrolled away. */
                let bundleTitle = document.querySelector('.bundle-builder__title');
                if(bundleTitle && !slideDownPriceInner.querySelector('.bundle-builder__slide-down-pricing-title')){
                    let bundleTitleClone = bundleTitle.cloneNode(true);
                    bundleTitleClone.classList.add('bundle-builder__slide-down-pricing-title');
                    bundleTitleClone.setAttribute('aria-hidden', 'true');
                    slideDownPriceInner.insertBefore(bundleTitleClone, slideDownPriceInner.firstChild);
                }

                if(price){slideDownPriceInner.appendChild(price);};
                if(shopifyInstallments){slideDownPriceInner.appendChild(shopifyInstallments);priceInstallmentsWrapper.setAttribute('data-display-installments-standin', true);};
                if(fsaHsa){slideDownPriceInner.appendChild(fsaHsa);priceInstallmentsWrapper.setAttribute('data-display-fsa-standin', true);};
                if(price){
                    const priceClone = price.cloneNode(true); // true means deep clone
                    const standInDiv = document.createElement('div');
                    standInDiv.classList.add('price__stand-in');
                    standInDiv.appendChild(priceClone);
                    priceInstallmentsWrapper.insertBefore(standInDiv, priceInstallmentsWrapper.firstChild);
                }
            }
        } else {
            if(slideDownPrice.getAttribute('data-has-contents') == 'true'){
                if(priceInstallmentsWrapper.querySelector('.price__stand-in')){
                    priceInstallmentsWrapper.querySelector('.price__stand-in').remove();
                }
                slideDownPrice.setAttribute('data-has-contents', 'false');
                let bundleTitleClone = slideDownPriceInner.querySelector('.bundle-builder__slide-down-pricing-title');
                if(bundleTitleClone){bundleTitleClone.remove();}
                if(price){priceInstallmentsWrapper.appendChild(price)};
                if(shopifyInstallments){priceInstallmentsWrapper.appendChild(shopifyInstallments);priceInstallmentsWrapper.removeAttribute('data-display-installments-standin');};
                if(fsaHsa){priceInstallmentsWrapper.appendChild(fsaHsa);priceInstallmentsWrapper.removeAttribute('data-display-fsa-standin');};
                priceInstallmentsWrapper.style.removeProperty('height');
            }
        }
    }
}

window.Branch.bundle.updateCTAURLParams = function(){
    if(document.querySelector('.bundle-builder__preset-cta-text-button')){
        let replacementParamString = ''
        selectVariantsArray.forEach((selectVariantSubArray, tab_loop_index) => {
            if(tab_loop_index < 2){
                let key = selectVariantSubArray[0]['collection'] == 'chairs' ? `${tab_loop_index == 0 ? '?' : '&'}pre_select_chair_product=` : `${tab_loop_index == 0 ? '?' : '&'}pre_select_desk_product=`
                // console.log('selectVariantSubArray', selectVariantSubArray)
                replacementParamString = `${replacementParamString}${key}${selectVariantSubArray[0]['variant_id']}`
            } else {
                if(selectVariantSubArray.length > 0){
                    let key = tab_loop_index == 2 ? '&pre_select_addon_product=' : '&pre_select_accessory_product=';
                    selectVariantSubArray.forEach((subSubArray, subSubArrayIndex) => {
                        if(subSubArrayIndex == 0){
                            replacementParamString = `${replacementParamString}${key}${subSubArray['variant_id']}`
                        } else {
                            replacementParamString = `${replacementParamString},${subSubArray['variant_id']}`
                        }
                    })
                }
            }
        })
        document.querySelector('.bundle-builder__preset-cta-text-button a').setAttribute('href', `/pages/bundles${replacementParamString}`)
    }
}

/* If bundle item is removed after the 'add to cart' button is pressed, allow customer to go back/forth again */
window.Branch.bundle.handleCartQuantityChange = function(){
    let checkoutStep = document.querySelectorAll('.bundle-builder__back-forward-buttons .bundle-builder__back-forward-button')[1].getAttribute('data-direction') == 'checkout';
    let allSelectedVariantsStillInCart = true;

    if(checkoutStep == true){
        let itemsInCart = document.querySelectorAll(`#side-cart .cart-items form .item`);
        let itemsInCartObject = {};

        itemsInCart.forEach((itemInCart) => {
            if(itemsInCartObject[`${itemInCart.getAttribute('data-variant-id')}`]) {
                itemsInCartObject[`${itemInCart.getAttribute('data-variant-id')}`] = itemsInCartObject[`${itemInCart.getAttribute('data-variant-id')}`] + parseInt(itemInCart.querySelector('.quantity-box input').value);
            } else {
                itemsInCartObject[`${itemInCart.getAttribute('data-variant-id')}`] = parseInt(itemInCart.querySelector('.quantity-box input').value);
            }
        })

        selectVariantsArray.forEach((selectVariantInnerArray) => {
            selectVariantInnerArray.forEach((selectVariant) => {
                if(!itemsInCartObject[`${selectVariant['variant_id']}`] || itemsInCartObject[`${selectVariant['variant_id']}`] == 0){
                    allSelectedVariantsStillInCart = false; 
                }
            })
        });

        if(allSelectedVariantsStillInCart != true){
            let back_button = backForwardButtonsContainer.querySelectorAll('.bundle-builder__back-forward-button')[0]
            let forward_button = backForwardButtonsContainer.querySelectorAll('.bundle-builder__back-forward-button')[1]
            
            forward_button.innerHTML = 'ADD TO CART'
            forward_button.setAttribute('data-direction', 'forward');

            back_button.innerHTML = 'BACK'
            back_button.setAttribute('data-direction', 'back');

            document.querySelectorAll('.bundle-builder-form__nav-button').forEach((navButton) => {
                navButton.setAttribute('data-step-unlocked', 'true')
            });

            saveSelectedVariantsToLocalStorage();
        }
    }
}

const repositionSlideDownPrice = function(){
    // The slide-down pricing bar now sits below the sticky header purely via the
    // --sticky-header-height CSS variable (kept current by sticky-header.js on
    // load + resize), so no inline top is set here. Previously this offset the
    // bar by the now-removed header slide-down nav's height, which resolved to 0
    // and put the bar behind the sticky header.
}

// const initSlideDownPrice = function(){
//     let  = document.querySelector('.bundle-builder__slide-down-pricing');
//     let priceInstallmentsWrapper = 


// }

/* Swaps the position of the desk/chair tabs based on entry point */
const setChairDeskOrder = function(){
    order_switched = false;
    // In the pop-up modal, ignore browse-history-based tab ordering — keep the prescribed order.
    if(isBundleBuilderInModal()){ return; }
    let reorderItems = false;
    let secondToLastVisitURL = window.Branch.functions.returnCookieURL('secondToLastVisitURL');
    if(secondToLastVisitURL.includes('/products/')){
        let urlHandle = secondToLastVisitURL.split('/products/')[1];
        let secondCollectionHandles = Array.from(document.querySelectorAll(`.bundle-builder-form__tabs-container .bundle-builder-form__tab[data-index="1"] .bundle-builder-form__product-container`), item => item.getAttribute('data-product-handle'));
        secondCollectionHandles.forEach((collectionHandle) => {
            if(urlHandle.includes(collectionHandle) || urlHandle == collectionHandle){
                reorderItems = true;
            }
        })
    }
    if(reorderItems){
        order_switched = true;
        let tab1Attributes = [{'id': 'second'}, {'data-index': 1}, {'data-showing': false}];
        let tab2Attributes = [{'id': 'first'}, {'data-index': 0}, {'data-showing': true}];
        swapAdjacentElements(document.querySelector(`.bundle-builder-form__tabs-container .bundle-builder-form__tab[data-index="0"]`), document.querySelector(`.bundle-builder-form__tabs-container .bundle-builder-form__tab[data-index="1"]`), tab1Attributes, tab2Attributes);
        
        let button1Attributes = [{'id': 'bundle-builder-form__nav-button--second'}, {'data-active': false}, {'data-index': 1}];
        let button2Attributes = [{'id': 'bundle-builder-form__nav-button--first'}, {'data-active': true}, {'data-index': 0}];
        swapAdjacentElements(document.querySelector(`.bundle-builder-form .bundle-builder-form__nav-button[data-index="0"]`), document.querySelector(`.bundle-builder-form .bundle-builder-form__nav-button[data-index="1"]`), button1Attributes, button2Attributes);
        
        let subtitle1Attributes = [{'data-showing': false}, {'aria-hidden': true}];
        let subtitle2Attributes = [{'data-showing': true}, {'aria-hidden': false}];
        swapAdjacentElements(document.querySelectorAll(`.bundle-builder-form .bundle-builder-form__nav-main-subtitle`)[0], document.querySelectorAll(`.bundle-builder-form .bundle-builder-form__nav-main-subtitle`)[1], subtitle1Attributes, subtitle2Attributes);

    }
}

var hjAttempts = 0;
var maxHjAttempts = 10;

const swatchesUpdate = function(){
    document.querySelectorAll('.bundle-builder-form__product-variants-inner-container').forEach((variantsContainer) => {
        let productHandle = variantsContainer.getAttribute('data-product-handle');
        let productContainer = document.querySelector(`.bundle-builder-form__product-container[data-product-handle="${productHandle}"]`);

        if(productContainer) {
            let productId = parseInt(productContainer.getAttribute('data-product-id'));
            let selectedVariantInput = variantsContainer.querySelector('input[name="id[]"]');
            let selected_product_data = products.find(product => product.id === productId);

            if(selectedVariantInput) {
                let selectedVariantId = parseInt(selectedVariantInput.value);
                let selectedVariant = variant_data[selectedVariantId];
                let productSwatches = variantsContainer.querySelectorAll('.swatch');

                if(productSwatches.length > 0 && selectedVariant) {
                    window.Branch.product.updateVariantSwatchTitles(productSwatches, selectedVariant, productId);
                    window.Branch.product.updateColorSwatchTabsSelectedIndicator(productSwatches, selectedVariant, productId);
                }

                // Check for addons to hide when desk/chair variant is changed (only for steps 1 and 2)
                let tabContainer = variantsContainer.closest('.bundle-builder-form__tab');
                if(tabContainer) {
                    let tabIndex = parseInt(tabContainer.getAttribute('data-index'));
                    if(tabIndex < 2 && selectedVariant) {
                        checkAddonsToHideForVariant(productId.toString(), selectedVariant, selected_product_data);
                    }
                }
            }
        }
    });
}

const hjFeedbackApplyCustomStyles = function() {
    hjAttempts = 11;
    const feedbackContainer = document.querySelector('._hj_feedback_container [class*="Feedback__container"]');
    if (feedbackContainer) {
        feedbackContainer.style.setProperty('--hjFeedbackAccentColor', '#8CAB91', 'important');
        feedbackContainer.style.setProperty('--hjFeedbackAccentHoverColor', '#8CAB91', 'important');
        feedbackContainer.style.setProperty('--hjFeedbackAccentActiveColor', '#8CAB91', 'important');
    }

    const hotjarBranding = document.querySelector('._hj_feedback_container [class*="HotjarBranding"]');
    if (hotjarBranding) {
        hotjarBranding.style.setProperty('visibility', 'hidden', 'important');
    }

    const minimizedWidget = document.querySelector('._hj_feedback_container [class*="MinimizedWidgetMiddle__emotionIcon"]');
    if (minimizedWidget) {
        minimizedWidget.style.setProperty('display', 'none', 'important');
    }

    const hjFeedbackContainer = document.querySelector('._hj_feedback_container');
    if (hjFeedbackContainer) {
        hjFeedbackContainer.style.setProperty('display', 'unset', 'important');
    }
}

function bundleBuilderFormInit() {
     /* Set order of chair/desks based on entry point */
    setChairDeskOrder();

    initReusableVariableDeclarations();

    repositionSlideDownPrice();

    /* Selects the addons that are compatible with the first selected desk and chair products */
    updateCompatibleAddons(-1, 'init')
    updateCompatibleAccessories(-1, 'init')

    updatePreSelectedNonDeskChairAddonProducts()

    /* Initializes the on-click event listeners on the buttons that switch back/forward between tabs */
    initNavButtonListeners();

    /* Initializes the on-click event listeners the product selection buttons in the carousel */
    initProductEventListener();

    /* Initializes all the product carousels */
    initProductsSlider();

    /* Initializes variant selection */
    const variantSelectObject = returnVariantSelectObject();
    // console.log('variantSelectObject', variantSelectObject)
    window.Branch.product.variantSelection('bundle-builder', variantSelectObject);
    selectFirstAvailableVariant();

    /* Initialize swatch tab dropdown event listeners */
    window.Branch.product.setUpSwatchTabsEventListener('bundle');

    /* Tag color swatch elements with bottom-row / data-element-in-row-has-label
       (used for the spacing rules in style_snippets_swatches.css), the same way
       mainProductReformat does for the regular PDP. */
    window.Branch.product.resizeSwatchesHeader('.bundle-builder-form');

    /* Add event listener using delegation */
    document.addEventListener('click', function(event) {
        const swatchLabel = event.target.closest('.bundle-builder-form .swatch-element label');

        if (swatchLabel) {
            setTimeout(() => {
                swatchesUpdate();
            }, 1000);
        }
    });

    /* Initializes pricing */
    window.Branch.bundle.updatePricing(true);

    /* Select the secondary gallery images that match the first selected desk/chair products */
    window.Branch.bundle.secondaryGalleryImages();

    /* Initializes the on-click events on the back/forward buttons */
    initBackForwardButtons();

    /* Pre-loads the layover and secondary images related to the first selected chair and desk products */
    window.Branch.bundle.bundleBuilderPreloadImages('init');

    /* Enables users to interact with carousel, removes the 'loading' styling */
    formContainer.setAttribute('data-enabled', true);

    /* Creates the summary tab based on the first selected chair/desk products */
    window.Branch.bundle.updateSummaryTab();

    /* Hides the addons that are not compatible with the first selected chair/desk products */
    hideShowAddons();

    /* Initializes the layover gallery */
    window.Branch.bundle.updateGalleryImage();

    window.Branch.bundle.updateCTAURLParams();

    adjustStickyTop();

    swatchesUpdate();

    // initSlideDownPrice();

    hjFeedbackApplyCustomStyles();
    setInterval(hjFeedbackApplyCustomStyles, 1000);

    const hjInterval = setInterval(() => {
        hjAttempts++;

        if (hjAttempts >= maxHjAttempts) {
            clearInterval(hjInterval); // Stop the interval

        }
    }, 1000);

    /* Adjust custom color swatch option styling on load and on resize */

    window.Branch.product.customSwatchContainerResize(`.bundle-builder-form`);
    
    var bbf_id;
    window.addEventListener("resize", function() {
        clearTimeout(bbf_id);
        bbf_id = setTimeout(function(){
            if (window.innerWidth != bundleBuilderWindowWidth) {
                mainProductWindowWidth = window.innerWidth
                window.Branch.product.customSwatchContainerResize(`.bundle-builder-form`);
                window.Branch.product.resizeSwatchesHeader(`.bundle-builder-form`);
                repositionSlideDownPrice();
            }
        }, 500);
    });
}

window.Branch = window.Branch || {};
window.Branch.bundle = window.Branch.bundle || {};
window.Branch.bundle.initForm = bundleBuilderFormInit;

if (document.readyState !== 'complete') {
    window.addEventListener("load", bundleBuilderFormInit);
}
